import "../styles/circuits.css"

export default function Circuits() {
  // Animation by Jennie Yip https://dribbble.com/jenniesyip
  return (
    <div className="circuit-container">
      <svg
        className="circuit-path"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: "absolute"}}
      >
        <defs>
          <linearGradient id="linear" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#148BB1" />
            <stop offset="100%" stopColor="#DBE2E8" />
          </linearGradient>
        </defs>
        <g
          id="module-01"
          transform="translate(-1.000000, 0.000000)"
          className="path path-01"
          stroke="url(#linear)"
          strokeWidth="4"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="butt"
          strokeLinejoin="round"
          strokeOpacity="1"
          strokeDasharray="8,960,24,960,16,400"
          strokeDashoffset="6400"
        >
          <g id="C23" transform="translate(177.000000, 0.000000)">
            <polyline points="52 92 84 92 116 60 116 0"></polyline>
            <polyline points="52 84 80 84 108 56 108 0"></polyline>
            <polyline points="52 76 76 76 100 52 100 0"></polyline>
            <polyline points="52 68 72 68 92 48 92 0"></polyline>
            <polyline points="52 60 68 60 84 44 84 0"></polyline>
            <path d="M16,56 L16,0"></path>
            <path d="M8,56 L8,0"></path>
            <path d="M24,56 L24,0"></path>
            <path d="M32,56 L32,0"></path>
            <path d="M40,56 L40,0"></path>
            <path d="M48,56 L48,0"></path>
            <path d="M0,92 L4,92"></path>
            <polyline points="52 100 56 100 72 100 80.0156098 108.01561 80.0156098 124.007338"></polyline>
            <path d="M0,100 L4,100"></path>
            <path d="M0,84 L4,84"></path>
            <path d="M0,76 L4,76"></path>
            <path d="M0,68 L4,68"></path>
            <path d="M0,60 L4,60"></path>
            <polyline points="96 284 88 284 84 288 32 288 16 272 16 108 16 104"></polyline>
            <polyline points="104 439 104 372 8 276 8 108 8 104"></polyline>
            <polyline points="124 272 88 272 80 280 36 280 24 268 24 108 24 104"></polyline>
            <polyline points="68 268 36 268 32 264 32 108 32 104"></polyline>
            <polyline points="44.0311289 252.000061 44.0311289 244.031129 40 240 40 108 40 104"></polyline>
            <polyline points="48 108 48 104 48 184 56 192 60 192 64 192"></polyline>
          </g>
          <g id="C22" transform="translate(0.000000, 239.000000)">
            <polyline points="1 0 25 0 57 32 57 156 69 168 69 172"></polyline>
            <polyline points="1 8 21 8 50 37 50 161 53 164 53 172"></polyline>
            <polyline points="1 32 8 32 24 48 24 169 12.954639 180.045361 13 248 13 257 0 270"></polyline>
            <polyline points="0 282 21 261 21 185 33 173 33 45 12 24 1 24"></polyline>
            <polyline points="0 317 0 293 29 264 29 189 41 177 41 40 17 16 1 16"></polyline>
          </g>
          <g id="C21" transform="translate(1.000000, 115.000000)">
            <polyline points="300 361 360 361 376.03122 344.96878 424 344.96878 471.000005 344.96878"></polyline>
            <polyline points="0 41 76 41 120 85 120 201 156 237 176 237 208 269 208 285 196 297 196 337 228 369 252 369"></polyline>
            <polyline points="300 369 391 369 395 365 464 365 468 361 476 361 520 405 556 405"></polyline>
            <polyline points="300 353 356 353 372 337 376 337 380 333"></polyline>
            <polyline points="0 17 88 17 144 73 144 181 224 261 224 293 212 305 212 329 236 353 252 353"></polyline>
            <polyline points="300 345 352 345 384 313"></polyline>
            <polyline points="224 317 224 329 240 345 252 345"></polyline>
            <polyline points="300 337 347 337 376 308 376 305 385 296"></polyline>
            <polyline points="136 12 136 21 152 37 152 177 232 257 232 293 236 297 236 329 244 337 252 337"></polyline>
            <polyline points="300 329 316 329 320 325 336 325"></polyline>
            <polyline points="348 597 328 597 304 573 304 409 296 401 296 373"></polyline>
            <polyline points="244 281 244 325 248 329 252 329"></polyline>
            <polyline points="264 325 264 265 168 169 168 29 160 21 160 12"></polyline>
            <polyline points="260 489 259.984385 441.015635 247.96878 429.000031 247.96878 413.03122 264 397 264 373"></polyline>
            <polyline points="256 325 256 269 160 173 160 33 148 21 148 0"></polyline>
            <polyline points="239 406 256 389 256 373"></polyline>
            <polyline points="272 325 272 261 176 165 176 25 172 21 172 1"></polyline>
            <polyline points="259 417 259 414 272 401 272 373"></polyline>
            <polyline points="272 433 272 413 280 405 280 373"></polyline>
            <polyline points="288 325 288 237 304 221 304 212"></polyline>
            <polyline points="348 605 323 605 296 578 296 414 288 406 288 373"></polyline>
            <polyline points="296 325 296 241 316 221 316 201"></polyline>
            <polyline points="0 33 79.9895845 32.9895845 128 81 128 197 144 213 164 213 216 265 216 289 204 301.285714 204 333.571429 231.428571 361 252 361"></polyline>
          </g>
          <g id="C20" transform="translate(1.000000, 622.000000)">
            <polyline points="0 21 88 21 101 8 101 1"></polyline>
            <polyline points="0 29 93 29 117.020824 4.9791757 117.020824 0.99994551"></polyline>
            <polyline points="0 37 96 37 133 0"></polyline>
            <polyline points="0 53 4 53 12 44.9377423 100 45 135 10 143 10 152 1"></polyline>
            <polyline points="0 61 9 61 17 53 104 53 140 17 164 17"></polyline>
          </g>
          <g id="C18" transform="translate(1.000000, 771.000000)">
            <polyline
              id="Path-4-Copy-466"
              points="0 137 60 137 100 97 100 29 100 20 119.026298 0.97370241 128.058497 0.97370241"
            ></polyline>
            <polyline
              id="Path-4-Copy-467"
              points="0 129 42 129 56 129 92 93 92 29 92 13 100.513149 4.4868512"
            ></polyline>
            <polyline
              id="Path-4-Copy-468"
              points="0 121 42 121 53 121 85 89 85 42 76 33 76 29 76 19"
            ></polyline>
            <polyline
              id="Path-4-Copy-469"
              points="0 113 42 113 47 113 75 85 75 43 65 33 65 29 65 5"
            ></polyline>
            <polyline
              id="Path-4-Copy-470"
              points="0 105 42 105 44 105 68 81 68 49 52 33 52 29 52 19"
            ></polyline>
            <polyline
              id="Path-4-Copy-165"
              points="0 145 67 145 76 136"
            ></polyline>
          </g>
          <g id="C17" transform="translate(217.000000, 519.000000)">
            <path d="M188,201 L203,201"></path>
            <polyline points="23 48 28 53 28 73 16 85 16 117 64 165 64 181 100 217 132 217"></polyline>
            <path d="M188,217 L203,217"></path>
            <polyline points="50.976204 135.999929 50.976204 139.976204 72 161 72 177 104 209 132 209"></polyline>
            <polyline points="0 48.9934213 0 125 48 173 48 189 92 233 132 233"></polyline>
            <path d="M188,233 L203,233"></path>
            <polyline points="13 68 8 73 8 121 56 169 56 185 96 225 132 225"></polyline>
            <polyline points="139 185 139 169 107 137 107 105 99 97 99 45"></polyline>
            <polyline points="41 445 41 427 52 416 52 377 140 289 140 281 140 241"></polyline>
            <polyline points="53 433 53 428 61 420 61 380 148 293 148 281 148 241"></polyline>
            <polyline points="65 445 65 428 69 424 69 384 156 296 156 281 156 241"></polyline>
            <polyline points="77 433 77 388 164 301 164 281 164 241"></polyline>
            <polyline points="125 428 125 424 129 420 129 348 172 305 172 281 172 241"></polyline>
            <polyline points="136 448 136 353 180 309 180 281 180 241"></polyline>
            <path d="M188,193 L193,193"></path>
            <path d="M188,209 L193,209"></path>
            <path d="M188,225 L193,225"></path>
            <polyline points="155 185 155 161 124 130 124 46"></polyline>
            <polyline points="147 185 147 164 116 133 116 89 112 85 112 57.9814878"></polyline>
            <polyline points="163 185 163 156 132 125 132 85 140 77 140 45"></polyline>
            <polyline points="171 185 171 153 140 122 140 88.984852 147.99243 80.9924224 147.99243 48.9999991 168.021383 28.9710453 200.000013 28.9710453 227.985533 0.985525461 244.000007 0.985525461 300.007241 56.9927599 316.000002 56.9927599 324.059116 48.9336452 336.000184 48.9336452"></polyline>
            <polyline points="179 185 179 149 148 118 148 92 156 84 156 61 169 48"></polyline>
          </g>
          <g id="C16" transform="translate(166.000000, 539.000000)">
            <polyline
              id="paths"
              points="43 317 43 261 43 240 72 211 72 173 68 169 68 156"
            ></polyline>
            <polyline
              id="paths"
              points="27 317 27 261 27 232 51 208 51 205"
            ></polyline>
            <polyline
              id="paths"
              points="59 317 59 261 59 248 88.0172363 218.982764 88.0172363 207.999986 92.1298907 203.887332 92.1298907 197"
            ></polyline>
            <polyline
              id="paths"
              points="51 317 51 261 51 244 80 215 80 168"
            ></polyline>
            <polyline
              id="paths"
              points="35 317 35 261 35 237 64 208 64 177 51 164 51 129 35 113 35 45 0 10 0 0"
            ></polyline>
            <polyline
              id="paths"
              points="19 317 19 261 19 229 36 212 36 137 16 117 16 88"
            ></polyline>
            <polyline
              id="paths"
              points="63 361 67 361 83 361 91.0156098 369.01561 91.0156098 385.007338"
            ></polyline>
            <polyline
              id="paths"
              points="59 369 59 365 59 445 67 453 71 453 75 453"
            ></polyline>
            <polyline
              id="paths"
              points="107 545 99 545 95 549 43 549 27 533 27 369 27 365"
            ></polyline>
            <polyline
              id="paths"
              points="79 529 47 529 43 525 43 369 43 365"
            ></polyline>
            <polyline
              id="paths"
              points="63 353 95 353 127 321 127 261 127 249 144 232"
            ></polyline>
            <polyline
              id="paths"
              points="63 345 91 345 119 317 119 261 119 241 129 231"
            ></polyline>
            <polyline
              id="paths"
              points="63 337 87 337 111 313 111 261 111 232"
            ></polyline>
            <polyline
              id="paths"
              points="63 329 83 329 103 309 103 261 103 252 99 248 99 244"
            ></polyline>
            <polyline
              id="paths"
              points="63 321 79 321 95 305 95 261 95 256 91 252"
            ></polyline>
            <polyline
              id="paths"
              points="115 700 115 633 19 537 19 369 19 365"
            ></polyline>
            <polyline
              id="paths"
              points="135 533 99 533 91 541 47 541 35 529 35 369 35 365"
            ></polyline>
            <polyline
              id="paths"
              points="55.0311289 513.000061 55.0311289 505.031129 51 501 51 369 51 365"
            ></polyline>
          </g>
          <g id="C14" transform="translate(309.000000, 0.000000)">
            <polyline points="272 196 288 196 300 208 300 224 324 248 416 248 421 243 428 243"></polyline>
            <polyline points="272 188 292 188 308 204 308 220 328 240 412.005952 240 420.002977 232.002976 480 232.002976 493.001488 219.001488 494 218 494 171"></polyline>
            <path d="M272,180 L284,180"></path>
            <path d="M272,172 L284,172"></path>
            <polyline points="380.05579 370.996531 371.003473 370.996531 368.000001 367.993058 324.006943 367.993058 296.013886 340.000001 296.013886 267.013886 260 231 260 216"></polyline>
            <polyline points="-2.52347418e-05 167.966704 20.9667036 167.966704 36 183 136 183 165 212 224 212"></polyline>
            <polyline points="272 212 280 212 284 216 284 232 312 260 312 296 368 352 396 352 400 348 408 348"></polyline>
            <polyline points="272 204 284 204 292 212 292 227 320 255 320 292.013511 371.993245 344.006756 392.02464 344.006756 401.069416 334.96198 420.000038 334.96198"></polyline>
            <polyline points="248 360 248 356 265 339 265 320 248 303 248 267 228 247 228 216"></polyline>
            <polyline points="280 352 280 276 244 240 244 216"></polyline>
            <polyline points="223 196 172 196 144 168 144 0"></polyline>
            <polyline points="236 168 236 148 272 112 272 0"></polyline>
            <polyline points="224 204 169 204 136 171 136 0"></polyline>
            <polyline points="228 167 228 144 264 108 264 0"></polyline>
            <polyline points="264.003967 360.000001 264.003967 351.003969 272 343.007936 272 280 236 244 236 216"></polyline>
            <polyline points="295.996576 360.000001 295.996576 352.003425 288 344.006849 288 271 252 235 252 216"></polyline>
            <path d="M420.005435,359 L328,359 L304,335 L304,264 L268,228 L268,216"></path>
            <polyline points="224.010169 188.022424 177.017751 188.022424 152 163.004673 152 56 152 0"></polyline>
            <polyline points="244 168 244 152 280 116 280 0"></polyline>
            <polyline points="224 180 181 180 160 159 160 0"></polyline>
            <polyline points="252 168 252 156 288 120 288 0"></polyline>
            <polyline points="224 172 185 172 168 155 168 0"></polyline>
            <polyline points="260 168 260 160 296 124 296 0"></polyline>
            <polyline points="268 168 268 164 304 128 304 0"></polyline>
          </g>
        </g>
        <g
          id="module-02"
          transform="translate(599.000000, 0.000000)"
          className="path path-02"
          stroke="url(#linear)"
          strokeWidth="4"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="butt"
          strokeLinejoin="round"
          strokeOpacity="1"
          strokeDasharray="8,960,24,960,16,400"
          strokeDashoffset="6400"
        >
          <g id="C12" transform="translate(377.000000, 0.000000)">
            <polyline points="52 92 84 92 116 60 116 0"></polyline>
            <polyline points="52 84 80 84 108 56 108 0"></polyline>
            <polyline points="52 76 76 76 100 52 100 0"></polyline>
            <polyline points="52 68 72 68 92 48 92 0"></polyline>
            <polyline points="52 60 68 60 84 44 84 0"></polyline>
            <path d="M16,56 L16,0"></path>
            <path d="M8,56 L8,0"></path>
            <path d="M24,56 L24,0"></path>
            <path d="M32,56 L32,0"></path>
            <path d="M40,56 L40,0"></path>
            <path d="M48,56 L48,0"></path>
            <path d="M0,92 L4,92"></path>
            <polyline points="52 100 56 100 72 100 80.0156098 108.01561 80.0156098 124.007338"></polyline>
            <path d="M0,100 L4,100"></path>
            <path d="M0,84 L4,84"></path>
            <path d="M0,76 L4,76"></path>
            <path d="M0,68 L4,68"></path>
            <path d="M0,60 L4,60"></path>
            <polyline points="96 284 88 284 84 288 32 288 16 272 16 108 16 104"></polyline>
            <polyline points="104 439 104 372 8 276 8 108 8 104"></polyline>
            <polyline points="124 272 88 272 80 280 36 280 24 268 24 108 24 104"></polyline>
            <polyline points="68 268 36 268 32 264 32 108 32 104"></polyline>
            <polyline points="44.0311289 252.000061 44.0311289 244.031129 40 240 40 108 40 104"></polyline>
            <polyline points="48 108 48 104 48 184 56 192 60 192 64 192"></polyline>
          </g>
          <g id="C10" transform="translate(0.000000, 675.000000)">
            <polyline points="29 153 29 181 49 201 65 201"></polyline>
            <polyline points="121 201 153 201 169 217 201 217 243 217 254 217 286 185 286 138 277 129 277 125 277 115"></polyline>
            <polyline points="45 153 45 173 57 185 65 185"></polyline>
            <polyline points="121 185 161.012498 185 177.00625 200.993752 201 200.993752 243 201 245 201 269 177 269 145 253 129 253 125 253 115"></polyline>
            <polyline points="121 217 145 217 161 233 201 233 261 233 301 193 301 125 301 116 320.026298 96.9737024 329.058497 96.9737024"></polyline>
            <polyline points="121 209 149 209 165 225 201 225 243 225 257 225 293 189 293 125 293 109 301.513149 100.486851"></polyline>
            <polyline points="121 193 157 193 173 209 201 209 243 209 248 209 276 181 276 139 266 129 266 125 266 101"></polyline>
            <polyline points="109 181 109 157 117 149 117 124.979176 117 77 138.023796 55.976204 182.000006 55.976204 196.98811 40.9881005 201.000018 40.9881005 213 41 217 37 309 37 318 28 318 13"></polyline>
            <polyline points="117 181 117 161 125 153 125 125 125 81 142 64 185.011626 64 200.005814 49.005812 201 49.005812 217 49 221 45 314 45 326 33 326 24 329 21 329 0"></polyline>
            <polyline points="93 181 93 149 101 141 101 124.96878 101 69 130 40 173 40 197 16 201 16 216 16"></polyline>
            <polyline points="121 225 141 225 157 241 201 241 268 241 277 232"></polyline>
            <polyline points="121 233 137 233 153 249 201 249 293 249 321 277 329 277 334 282"></polyline>
            <polyline points="37 153 37 177 53 193 65 193"></polyline>
            <polyline points="35 246 48 233 65 233"></polyline>
            <polyline points="69 181 69 125 69 96"></polyline>
            <polyline points="23.9999921 311.98812 32.9880842 311.98812 36.976204 308 58 308 93 273 93 237"></polyline>
            <polyline points="85 181 85 145 93 137 93 125 93 57 102 48"></polyline>
            <polyline points="101 181 101 153 109 145 109 125 109 74 134 49 177 49 197 29 200 29"></polyline>
            <path d="M29,216.666667 L65,216.666667"></path>
            <polyline points="29 201 37 201 45 209 65 209"></polyline>
            <polyline points="29 233 37 233 45 225 65 225"></polyline>
            <polyline points="12 277 21 277 29 285 45 285 69 261 69 237"></polyline>
            <polyline points="120.996096 317.000001 120.996096 305.003908 117 301.007812 117 237"></polyline>
            <polyline points="11.9878067 300 53 300 85 268 85 237"></polyline>
            <polyline points="77 181 77 141 81 137 81 126"></polyline>
            <polyline points="0 288 20 288 24 292 49 292 77 264 77 237"></polyline>
            <polyline points="35.9999987 324.003205 41.0032034 324.003205 48.9999983 316.00641 61.0064087 316.00641 101 276.012818 101 237"></polyline>
            <path d="M108.666667,305.029405 L108.666667,237"></path>
          </g>
          <g id="C5" transform="translate(116.000000, 1027.000000)">
            <polyline points="59 329 59 295 86.5045451 267.495455 89 265 89 194 86 191 61 166 61 105 65 101 65 96"></polyline>
            <polyline points="75 329 75 303 88.0384048 289.961595 105 273 105 197 117 185 117 57 96 36 85 36 70 36 61 45 41 45 37 49 30 49"></polyline>
            <polyline points="67 329 67 299 87.0249844 278.975016 97 269 97 260 96.954639 192.045361 108 181 108 60 92 44 85 44 73 44 64.9377423 52.0622577 52.9998377 52.0622577 45.0309872 60.0311082 41.9998404 60.0311082"></polyline>
            <polyline points="0.96159519 40 14 40 17 37 56 37 65 28 85 28 101 28 125 52 125 189 113 201 113 276 84 305 84 329"></polyline>
            <polyline points="109 369 129 369 149 389 149 397"></polyline>
            <polyline points="109 377 126 377 133.071068 384.071068 133.071068 397.000195"></polyline>
            <polyline points="109 345 121 345 137 329 137 309"></polyline>
            <polyline points="109 337 117 337 126 328 126 320"></polyline>
            <polyline points="109 361 129 361 161 329 161 309"></polyline>
            <polyline points="109 353 125 353 150 328 150 320"></polyline>
            <polyline points="101 329 101 313 125.020824 288.979176 173.000005 288.979176 189.989593 271.989587 189.989593 243.999998"></polyline>
            <polyline points="93 329 93 309 121.017851 280.982149 169.010795 280.982149 177.996472 271.996471 177.996472 192.993715 149.001378 163.998622 149.001378 41 108.988174 0.986795729 100.999989 0.986795729"></polyline>
          </g>
        </g>
        <g
          id="module-03"
          transform="translate(1024.000000, 164.000000)"
          className="path path-03"
          stroke="url(#linear)"
          strokeWidth="4"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="butt"
          strokeLinejoin="round"
          strokeOpacity="1"
          strokeDasharray="8,960,24,960,16,400"
          strokeDashoffset="6400"
        >
          <g id="C11" transform="translate(8.000000, 0.000000)">
            <polyline points="48 52 195 52 228 85 228 176 300 248 372 248 392 228 432 228 464 260 516 260 520 256 520 248"></polyline>
            <polyline points="48 44 199 44 235 80 235 171.005494 283.997253 220.002747 436 220.002747 448.040112 232.042859 455.065506 232.042859"></polyline>
            <polyline points="48 36 203 36 244 77 244 168 288 212 439 212 447 220 482 220"></polyline>
            <path d="M48,28 L207,28 L252,73 L252,164 C252,164 267,180 268,180 L276,180 L281,185"></path>
            <path d="M0,60 L8,60"></path>
            <path d="M4,52 L8,52"></path>
            <path d="M0,44 L8,44"></path>
            <path d="M4,36 L8,36"></path>
            <path d="M28,72 L28,64"></path>
            <polyline points="44 24 44 20 48 16 84 16"></polyline>
            <polyline points="56 76 52 76 44 68 44 64"></polyline>
            <path d="M20,24 L20,20"></path>
            <path d="M28,24 L28,20"></path>
            <polyline points="12 24 12 20 8 16 8 0"></polyline>
            <path d="M36,24 L36,20"></path>
          </g>
          <g id="C9" transform="translate(237.000000, 252.000000)">
            <path d="M135,39 L135,27"></path>
            <path d="M151,39 L151,27"></path>
            <path d="M143,39 L143,27"></path>
            <polyline points="18 0 27 0 55 28 95 28 115 48 127 48"></polyline>
            <polyline points="175 48 287 48 303 64 311 64"></polyline>
            <polyline points="18 23 27 23 47 43 86 43 107 64 127 64"></polyline>
            <polyline points="175 64 279 64 291.041595 76.0415946 291.041595 83.0001243"></polyline>
            <polyline points="-8.03677904e-06 10.9791757 26.9791757 10.9791757 51 35 90 35 111 56 127 56"></polyline>
            <polyline points="175 56 283.00463 56 300.002315 72.9976854"></polyline>
            <polyline points="72 92 98 92 110 80 127 80"></polyline>
            <polyline points="175 80 187 80 203 96 211 96 215 92 227 92"></polyline>
            <polyline points="84 80 99 80 107 72 127 72"></polyline>
            <polyline points="175 72 259 72 263 76 270 76"></polyline>
            <polyline points="139.02077 155.000054 139.02077 151.020824 147.041595 143 147.041595 128.041595 135 116 135 88"></polyline>
            <polyline points="162 147 162 119 151 108 151 88"></polyline>
            <polyline points="155 155 155 124 143 112 143 88"></polyline>
            <polyline points="159 39 159 27 175 11 181 11"></polyline>
            <polyline points="171 155 171 116 159 104 159 88"></polyline>
            <polyline points="167 39 167 32 176 23 203 23 219 39 290 39 299 48 311 48"></polyline>
            <polyline points="183 144 183 136 179 132 179 111 167 99 167 88"></polyline>
          </g>
          <g id="C8" transform="translate(237.000000, 1052.000000)">
            <path d="M135,39 L135,27"></path>
            <path d="M151,39 L151,27"></path>
            <path d="M143,39 L143,27"></path>
            <polyline points="18 0 27 0 55 28 95 28 115 48 127 48"></polyline>
            <polyline points="175 48 287 48 303 64 311 64"></polyline>
            <polyline points="18 23 27 23 47 43 86 43 107 64 127 64"></polyline>
            <polyline points="175 64 279 64 291.041595 76.0415946 291.041595 83.0001243"></polyline>
            <polyline points="-8.03677904e-06 10.9791757 26.9791757 10.9791757 51 35 90 35 111 56 127 56"></polyline>
            <polyline points="175 56 283.00463 56 300.002315 72.9976854"></polyline>
            <polyline points="72 92 98 92 110 80 127 80"></polyline>
            <polyline points="175 80 187 80 203 96 211 96 215 92 227 92"></polyline>
            <polyline points="84 80 99 80 107 72 127 72"></polyline>
            <polyline points="175 72 259 72 263 76 270 76"></polyline>
            <polyline points="139.02077 155.000054 139.02077 151.020824 147.041595 143 147.041595 128.041595 135 116 135 88"></polyline>
            <polyline points="162 147 162 119 151 108 151 88"></polyline>
            <polyline points="155 155 155 124 143 112 143 88"></polyline>
            <polyline points="159 39 159 27 175 11 181 11"></polyline>
            <polyline points="171 155 171 116 159 104 159 88"></polyline>
            <polyline points="167 39 167 32 176 23 203 23 219 39 290 39 299 48 311 48"></polyline>
            <polyline points="183 144 183 136 179 132 179 111 167 99 167 88"></polyline>
          </g>
          <g id="C7" transform="translate(144.000000, 558.000000)">
            <polyline points="53 162 61 162 68 154 68 114 52 98 52 78 52 74 69 57 69 24 85 8 85 0"></polyline>
            <path d="M12,154 L12,144"></path>
            <polyline points="0 245 0 230 12 218 12 202"></polyline>
            <polyline points="13 245 13 229 20 222 20 202"></polyline>
            <path d="M28,154 L28,128"></path>
            <polyline points="49 245 49 237 28 216 28 202"></polyline>
            <polyline points="44 154 44 145 53 136 53 128"></polyline>
            <polyline points="65 245 65 229 44 209 44 202"></polyline>
            <polyline points="36 153 36 78 36 65 52 49"></polyline>
          </g>
          <g id="C6" transform="translate(491.000000, 63.000000)">
            <polyline points="59 329 59 295 86.5045451 267.495455 89 265 89 194 86 191 61 166 61 105 65 101 65 96"></polyline>
            <polyline points="75 329 75 303 88.0384048 289.961595 105 273 105 197 117 185 117 57 96 36 85 36 70 36 61 45 41 45 37 49 30 49"></polyline>
            <polyline points="67 329 67 299 87.0249844 278.975016 97 269 97 260 96.954639 192.045361 108 181 108 60 92 44 85 44 73 44 64.9377423 52.0622577 52.9998377 52.0622577 45.0309872 60.0311082 41.9998404 60.0311082"></polyline>
            <polyline points="0.96159519 40 14 40 17 37 56 37 65 28 85 28 101 28 125 52 125 189 113 201 113 276 84 305 84 329"></polyline>
            <polyline points="109 369 129 369 149 389 149 397"></polyline>
            <polyline points="109 377 126 377 133.071068 384.071068 133.071068 397.000195"></polyline>
            <polyline points="109 345 121 345 137 329 137 309"></polyline>
            <polyline points="109 337 117 337 126 328 126 320"></polyline>
            <polyline points="109 361 129 361 161 329 161 309"></polyline>
            <polyline points="109 353 125 353 150 328 150 320"></polyline>
            <polyline points="101 329 101 313 125.020824 288.979176 173.000005 288.979176 189.989593 271.989587 189.989593 243.999998"></polyline>
            <polyline points="93 329 93 309 121.017851 280.982149 169.010795 280.982149 177.996472 271.996471 177.996472 192.993715 149.001378 163.998622 149.001378 41 108.988174 0.986795729 100.999989 0.986795729"></polyline>
          </g>
          <g id="C3" transform="translate(0.000000, 740.000000)">
            <polyline points="56 112 203 112 236 145 236 236 308 308 380 308 400 288 440 288 472 320 524 320 528 316 528 308"></polyline>
            <polyline points="56 104 207 104 243 140 243 231.005494 291.997253 280.002747 444 280.002747 456.040112 292.042859 463.065506 292.042859"></polyline>
            <polyline points="56 96 211 96 252 137 252 228 296 272 447 272 455 280 490 280"></polyline>
            <path d="M56,88 L215,88 L260,133 L260,224 C260,224 275,240 276,240 L284,240 L289,245"></path>
            <path d="M8,120 L16,120"></path>
            <path d="M8,104 L16,104"></path>
            <polyline points="52 84 52 80 56 76 92 76"></polyline>
            <path d="M28,84 L28,80"></path>
            <polyline points="20 84 20 80 16 76 16 60"></polyline>
            <path d="M36,132 L36,124"></path>
            <polyline points="0 4 0 0 0 80 8 88 12 88 16 88"></polyline>
            <polyline points="64 136 60 136 52 128 52 124"></polyline>
          </g>
        </g>
        <g
          id="module-04"
          transform="translate(1532.000000, 115.000000)"
          className="path path-04"
          stroke="url(#linear)"
          strokeWidth="4"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="butt"
          strokeLinejoin="round"
          strokeOpacity="1"
          strokeDasharray="8,960,24,960,16,400"
          strokeDashoffset="6400"
        >
          <g id="C19">
            <polyline points="368 361 428 361 444.03122 344.96878 492 344.96878 539.000005 344.96878"></polyline>
            <polyline points="0 52 12 52 23 41 68 41 144 41 188 85 188 201 224 237 244 237 276 269 276 285 264 297 264 337 296 369 320 369"></polyline>
            <polyline points="368 369 459 369 463 365 532 365 536 361 544 361 588 405 624 405"></polyline>
            <polyline points="368 353 424 353 440 337 444 337 448 333"></polyline>
            <polyline points="0 4 4 4 17 17 68 17 156 17 212 73 212 181 292 261 292 293 280 305 280 329 304 353 320 353"></polyline>
            <polyline points="368 345 420 345 452 313"></polyline>
            <polyline points="292 317 292 329 308 345 320 345"></polyline>
            <polyline points="368 337 415 337 444 308 444 305 453 296"></polyline>
            <polyline points="204 12 204 21 220 37 220 177 300 257 300 293 304 297 304 329 312 337 320 337"></polyline>
            <polyline points="368 329 384 329 388 325 404 325"></polyline>
            <polyline points="416 597 396 597 372 573 372 409 364 401 364 373"></polyline>
            <polyline points="312 281 312 325 316 329 320 329"></polyline>
            <polyline points="332 325 332 265 236 169 236 29 228 21 228 12"></polyline>
            <polyline points="328 489 327.984385 441.015635 315.96878 429.000031 315.96878 413.03122 332 397 332 373"></polyline>
            <polyline points="324 325 324 269 228 173 228 33 216 21 216 0"></polyline>
            <polyline points="307 406 324 389 324 373"></polyline>
            <polyline points="340 325 340 261 244 165 244 25 240 21 240 1"></polyline>
            <polyline points="327 417 327 414 340 401 340 373"></polyline>
            <polyline points="340 433 340 413 348 405 348 373"></polyline>
            <polyline points="356 325 356 237 372 221 372 212"></polyline>
            <polyline points="416 605 391 605 364 578 364 414 356 406 356 373"></polyline>
            <polyline points="364 325 364 241 384 221 384 201"></polyline>
            <polyline points="0 36 17 36 20 33 68 33 147.989584 32.9895845 196 81 196 197 212 213 232 213 284 265 284 289 272 301.285714 272 333.571429 299.428571 361 320 361"></polyline>
          </g>
          <g id="C15" transform="translate(233.000000, 424.000000)">
            <polyline points="43 317 43 261 43 240 72 211 72 173 68 169 68 156"></polyline>
            <polyline points="27 317 27 261 27 232 51 208 51 205"></polyline>
            <polyline points="59 317 59 261 59 248 88.0172363 218.982764 88.0172363 207.999986 92.1298907 203.887332 92.1298907 197"></polyline>
            <polyline points="51 317 51 261 51 244 80 215 80 168"></polyline>
            <polyline points="35 317 35 261 35 237 64 208 64 177 51 164 51 129 35 113 35 45 0 10 0 0"></polyline>
            <polyline points="19 317 19 261 19 229 36 212 36 137 16 117 16 88"></polyline>
            <polyline points="63 361 67 361 83 361 91.0156098 369.01561 91.0156098 385.007338"></polyline>
            <polyline points="59 369 59 365 59 445 67 453 71 453 75 453"></polyline>
            <polyline points="107 545 99 545 95 549 43 549 27 533 27 369 27 365"></polyline>
            <polyline points="79 529 47 529 43 525 43 369 43 365"></polyline>
            <polyline points="63 353 95 353 127 321 127 261 127 249 144 232"></polyline>
            <polyline points="63 345 91 345 119 317 119 261 119 241 129 231"></polyline>
            <polyline points="63 337 87 337 111 313 111 261 111 232"></polyline>
            <polyline points="63 329 83 329 103 309 103 261 103 252 99 248 99 244"></polyline>
            <polyline points="63 321 79 321 95 305 95 261 95 256 91 252"></polyline>
            <polyline points="115 700 115 633 19 537 19 369 19 365"></polyline>
            <polyline points="135 533 99 533 91 541 47 541 35 529 35 369 35 365"></polyline>
            <polyline points="55.0311289 513.000061 55.0311289 505.031129 51 501 51 369 51 365"></polyline>
          </g>
          <g id="C4" transform="translate(4.000000, 547.000000)">
            <polyline points="28 126 64 126 96 126 105 117 105 113"></polyline>
            <polyline points="28 110 40 110 65 84 72 77 88 77 92 73 184.005435 73 204.02757 52.9778651"></polyline>
            <polyline points="24 106 24 91 30 85 52 85 64.509996 72.490004 68 69 84 69 88 65 180 65 196 49 196 41 204.062258 32.9377423 204.062258 0.982339396"></polyline>
            <polyline points="28 118 43 118 65 96 76 85 96 85"></polyline>
            <polyline points="16 106 16 102 12 98 12 94"></polyline>
            <polyline points="0 174 0 166 8 158 8 154"></polyline>
            <path d="M15.6666667,174 L15.6666667,154"></path>
            <polyline points="33 175 24 166 24 154"></polyline>
            <polyline points="229 229 229 194 236 187 236 138 236 106 256 86 256 18 239 1 224 1"></polyline>
            <polyline points="189 274 189 253 220 222 220 190 228 182 228 138 228 129 224 125 224 117"></polyline>
            <polyline points="149 101 153 101 157 97 205 97 224.026298 77.9737024 236.000029 77.9737024"></polyline>
          </g>
          <g id="C1" transform="translate(0.000000, 800.000000)">
            <polyline points="0 52 12 52 23 41 68 41 144 41 188 85 188 201 224 237 244 237 276 269 276 285 264 297 264 337 296 369 320 369"></polyline>
            <polyline points="368 369 459 369 463 365 532 365 536 361 544 361 588 405 624 405"></polyline>
            <polyline points="368 353 424 353 440 337 444 337 448 333"></polyline>
            <polyline points="0 4 4 4 17 17 68 17 156 17 212 73 212 181 292 261 292 293 280 305 280 329 304 353 320 353"></polyline>
            <polyline points="0 36 17 36 20 33 68 33 147.989584 32.9895845 196 81 196 197 212 213 232 213 284 265 284 289 272 301.285714 272 333.571429 299.428571 361 320 361"></polyline>
            <polyline points="292 317 292 329 308 345 320 345"></polyline>
            <polyline points="204 12 204 21 220 37 220 177 300 257 300 293 304 297 304 329 312 337 320 337"></polyline>
            <polyline points="368 329 384 329 388 325 404 325"></polyline>
            <polyline points="416 597 396 597 372 573 372 409 364 401 364 373"></polyline>
            <polyline points="312 281 312 325 316 329 320 329"></polyline>
            <polyline points="332 325 332 265 236 169 236 29 228 21 228 12"></polyline>
            <polyline points="324 325 324 269 228 173 228 33 216 21 216 0"></polyline>
            <polyline points="368 361 428 361 444.03122 344.96878 492 344.96878 539.000005 344.96878"></polyline>
            <polyline points="368 345 420 345 452 313"></polyline>
            <polyline points="368 337 415 337 444 308 444 305 453 296"></polyline>
            <polyline points="328 489 327.984385 441.015635 315.96878 429.000031 315.96878 413.03122 332 397 332 373"></polyline>
            <polyline points="307 406 324 389 324 373"></polyline>
            <polyline points="327 417 327 414 340 401 340 373"></polyline>
            <polyline points="340 433 340 413 348 405 348 373"></polyline>
            <polyline points="340 325 340 261 244 165 244 25 240 21 240 1"></polyline>
            <polyline points="356 325 356 237 372 221 372 212"></polyline>
            <polyline points="416 605 391 605 364 578 364 414 356 406 356 373"></polyline>
            <polyline points="364 325 364 241 384 221 384 201"></polyline>
          </g>
        </g>
        <g
          id="module-05"
          transform="translate(1908.000000, 0.000000)"
          className="path path-05"
          stroke="url(#linear)"
          strokeWidth="4"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="butt"
          strokeLinejoin="round"
          strokeOpacity="1"
          strokeDasharray="8,960,24,960,16,400"
          strokeDashoffset="6400"
        >
          <g id="C13">
            <polyline points="272 196 288 196 300 208 300 224 324 248 416 248 421 243 428 243"></polyline>
            <polyline points="272 188 292 188 308 204 308 220 328 240 412.005952 240 420.002977 232.002976 480 232.002976 493.001488 219.001488 494 218 494 171"></polyline>
            <path d="M272,180 L284,180"></path>
            <path d="M272,172 L284,172"></path>
            <polyline points="380.05579 370.996531 371.003473 370.996531 368.000001 367.993058 324.006943 367.993058 296.013886 340.000001 296.013886 267.013886 260 231 260 216"></polyline>
            <polyline points="-2.52347418e-05 167.966704 20.9667036 167.966704 36 183 136 183 165 212 224 212"></polyline>
            <polyline points="272 212 280 212 284 216 284 232 312 260 312 296 368 352 396 352 400 348 408 348"></polyline>
            <polyline points="272 204 284 204 292 212 292 227 320 255 320 292.013511 371.993245 344.006756 392.02464 344.006756 401.069416 334.96198 420.000038 334.96198"></polyline>
            <polyline points="248 360 248 356 265 339 265 320 248 303 248 267 228 247 228 216"></polyline>
            <polyline points="280 352 280 276 244 240 244 216"></polyline>
            <polyline points="223 196 172 196 144 168 144 0"></polyline>
            <polyline points="236 168 236 148 272 112 272 0"></polyline>
            <polyline points="224 204 169 204 136 171 136 0"></polyline>
            <polyline points="228 167 228 144 264 108 264 0"></polyline>
            <polyline points="264.003967 360.000001 264.003967 351.003969 272 343.007936 272 280 236 244 236 216"></polyline>
            <polyline points="295.996576 360.000001 295.996576 352.003425 288 344.006849 288 271 252 235 252 216"></polyline>
            <path d="M420.005435,359 L328,359 L304,335 L304,264 L268,228 L268,216"></path>
            <polyline points="224.010169 188.022424 177.017751 188.022424 152 163.004673 152 56 152 0"></polyline>
            <polyline points="244 168 244 152 280 116 280 0"></polyline>
            <polyline points="224 180 181 180 160 159 160 0"></polyline>
            <polyline points="252 168 252 156 288 120 288 0"></polyline>
            <polyline points="224 172 185 172 168 155 168 0"></polyline>
            <polyline points="260 168 260 160 296 124 296 0"></polyline>
            <polyline points="268 168 268 164 304 128 304 0"></polyline>
          </g>
          <g id="C2" transform="translate(291.000000, 691.000000)">
            <polyline points="85 165 85 129 93 121 93 109 93 41 102 32"></polyline>
            <polyline points="93 165 93 133 101 125 101 108.96878 101 53 130 24 173 24 197 0 201 0"></polyline>
            <polyline points="101 165 101 137 109 129 109 109 109 58 134 33 177 33 197 13 200 13"></polyline>
            <polyline points="109 165 109 141 117 133 117 108.979176 117 61 138.023796 39.976204 182.000006 39.976204 196.98811 24.9881005 201.000018 24.9881005"></polyline>
            <polyline points="117 165 117 145 125 137 125 109 125 65 142 48 185.011626 48 200.005814 33.005812 201 33.005812"></polyline>
            <polyline points="29 137 29 165 49 185 65 185"></polyline>
            <polyline points="29 185 37 185 45 193 65 193"></polyline>
            <polyline points="35 230 48 217 65 217"></polyline>
            <polyline points="69 165 69 109 69 80"></polyline>
            <polyline points="12 261 21 261 29 269 45 269 69 245 69 221"></polyline>
            <polyline points="11.9878067 284 53 284 85 252 85 221"></polyline>
            <polyline points="77 165 77 125 81 121 81 110"></polyline>
            <polyline points="0 272 20 272 24 276 49 276 77 248 77 221"></polyline>
            <polyline points="35.9999987 308.003205 41.0032034 308.003205 48.9999983 300.00641 61.0064087 300.00641 101 260.012818 101 221"></polyline>
            <polyline points="121 185 153 185 169 201 201 201"></polyline>
            <path d="M29,200.666667 L65,200.666667"></path>
            <polyline points="121 201 145 201 161 217 201 217"></polyline>
            <polyline points="45 137 45 157 57 169 65 169"></polyline>
            <polyline points="121 169 161.012498 169 177.00625 184.993752 201 184.993752"></polyline>
            <polyline points="37 137 37 161 53 177 65 177"></polyline>
            <polyline points="121 177 157 177 173 193 201 193"></polyline>
            <polyline points="121 193 149 193 165 209 201 209"></polyline>
            <polyline points="121 217 137 217 153 233 201 233"></polyline>
            <polyline points="29 217 37 217 45 209 65 209"></polyline>
            <polyline points="121 209 141 209 157 225 201 225"></polyline>
            <polyline points="23.9999921 295.98812 32.9880842 295.98812 36.976204 292 58 292 93 257 93 221"></polyline>
            <path d="M108.666667,289.029405 L108.666667,221"></path>
            <polyline points="120.996096 301.000001 120.996096 289.003908 117 285.007812 117 221"></polyline>
          </g>
        </g>

        <g
          id="static"
          transform="translate(48.000000, 56.000000)"
          stroke="#DDE0E2"
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="132" y="0" width="48" height="48" rx="4"></rect>
          <circle cx="172" cy="200" r="4"></circle>
          <circle cx="200" cy="212" r="4"></circle>
          <circle cx="228" cy="228" r="4"></circle>
          <circle cx="256" cy="216" r="4"></circle>
          <circle cx="208" cy="72" r="4"></circle>
          <circle cx="20" cy="359" r="4"></circle>
          <circle cx="4" cy="359" r="4"></circle>
          <rect x="204" y="384" width="48" height="48" rx="4"></rect>
          <circle cx="268" cy="256" r="4"></circle>
          <circle cx="256" cy="267" r="4"></circle>
          <circle cx="512" cy="464" r="4"></circle>
          <circle cx="427" cy="404" r="4"></circle>
          <circle cx="88" cy="67" r="4"></circle>
          <circle cx="100" cy="55" r="4"></circle>
          <circle cx="112" cy="67" r="4"></circle>
          <circle cx="124" cy="55" r="4"></circle>
          <circle cx="335" cy="388" r="4"></circle>
          <circle cx="339" cy="368" r="4"></circle>
          <circle cx="340" cy="352" r="4"></circle>
          <circle cx="292" cy="384" r="4"></circle>
          <circle cx="188" cy="468" r="4"></circle>
          <circle cx="196" cy="336" r="4"></circle>
          <circle cx="176" cy="372" r="4"></circle>
          <circle cx="224" cy="496" r="4"></circle>
          <circle cx="211" cy="480" r="4"></circle>
          <circle cx="53" cy="563" r="4"></circle>
          <circle cx="120" cy="583" r="4"></circle>
          <circle cx="69" cy="563" r="4"></circle>
          <circle cx="107" cy="563" r="4"></circle>
          <circle cx="88" cy="563" r="4"></circle>
          <rect x="1804" y="384" width="48" height="48" rx="4"></rect>
          <circle cx="1868" cy="256" r="4"></circle>
          <circle cx="1856" cy="267" r="4"></circle>
          <circle cx="2112" cy="464" r="4"></circle>
          <circle cx="2027" cy="404" r="4"></circle>
          <circle cx="1688" cy="67" r="4"></circle>
          <circle cx="1700" cy="55" r="4"></circle>
          <circle cx="1712" cy="67" r="4"></circle>
          <circle cx="1724" cy="55" r="4"></circle>
          <circle cx="1935" cy="388" r="4"></circle>
          <circle cx="1939" cy="368" r="4"></circle>
          <circle cx="1940" cy="352" r="4"></circle>
          <circle cx="1892" cy="384" r="4"></circle>
          <circle cx="1788" cy="468" r="4"></circle>
          <circle cx="1796" cy="336" r="4"></circle>
          <circle cx="1776" cy="372" r="4"></circle>
          <circle cx="1824" cy="496" r="4"></circle>
          <circle cx="1811" cy="480" r="4"></circle>
          <circle cx="1480" cy="63" r="4"></circle>
          <circle cx="1480" cy="95" r="4"></circle>
          <circle cx="1480" cy="111" r="4"></circle>
          <circle cx="4" cy="729" r="4"></circle>
          <circle cx="17" cy="716" r="4"></circle>
          <circle cx="56" cy="716" r="4"></circle>
          <circle cx="84" cy="716" r="4"></circle>
          <circle cx="28" cy="729" r="4"></circle>
          <circle cx="31" cy="848" r="4"></circle>
          <rect x="300" y="648" width="56" height="56" rx="4"></rect>
          <circle cx="508" cy="512" r="4"></circle>
          <circle cx="340" cy="508" r="4"></circle>
          <circle cx="168" cy="508" r="4"></circle>
          <circle cx="188" cy="508" r="4"></circle>
          <circle cx="184" cy="528" r="4"></circle>
          <circle cx="308" cy="504" r="4"></circle>
          <circle cx="292" cy="504" r="4"></circle>
          <circle cx="267" cy="504" r="4"></circle>
          <circle cx="280" cy="517" r="4"></circle>
          <circle cx="304" cy="915" r="4"></circle>
          <circle cx="293" cy="895" r="4"></circle>
          <circle cx="245" cy="900" r="4"></circle>
          <circle cx="221" cy="900" r="4"></circle>
          <circle cx="233" cy="912" r="4"></circle>
          <circle cx="209" cy="912" r="4"></circle>
          <circle cx="375" cy="696" r="4"></circle>
          <circle cx="375" cy="680" r="4"></circle>
          <circle cx="375" cy="664" r="4"></circle>
          <circle cx="185" cy="635" r="4"></circle>
          <circle cx="168" cy="684" r="4"></circle>
          <rect x="132" y="800" width="48" height="48" rx="4"></rect>
          <circle cx="117" cy="479" r="4"></circle>
          <circle cx="133" cy="567" r="4"></circle>
          <circle cx="209" cy="676" r="4"></circle>
          <circle cx="197" cy="647" r="4"></circle>
          <circle cx="228" cy="1028" r="4"></circle>
          <circle cx="208" cy="872" r="4"></circle>
          <circle cx="264" cy="711" r="4"></circle>
          <circle cx="249" cy="711" r="4"></circle>
          <circle cx="228" cy="711" r="4"></circle>
          <circle cx="216" cy="723" r="4"></circle>
          <circle cx="205" cy="731" r="4"></circle>
          <circle cx="256" cy="1016" r="4"></circle>
          <circle cx="200" cy="1012" r="4"></circle>
          <circle cx="172" cy="1000" r="4"></circle>
          <circle cx="1785" cy="635" r="4"></circle>
          <circle cx="1768" cy="684" r="4"></circle>
          <rect x="1732" y="800" width="48" height="48" rx="4"></rect>
          <circle cx="1717" cy="479" r="4"></circle>
          <circle cx="1733" cy="567" r="4"></circle>
          <circle cx="1809" cy="676" r="4"></circle>
          <circle cx="1797" cy="647" r="4"></circle>
          <circle cx="1828" cy="1028" r="4"></circle>
          <circle cx="1808" cy="872" r="4"></circle>
          <circle cx="1864" cy="711" r="4"></circle>
          <circle cx="1849" cy="711" r="4"></circle>
          <circle cx="1828" cy="711" r="4"></circle>
          <circle cx="1816" cy="723" r="4"></circle>
          <circle cx="1805" cy="731" r="4"></circle>
          <circle cx="1856" cy="1016" r="4"></circle>
          <circle cx="1800" cy="1012" r="4"></circle>
          <circle cx="1772" cy="1000" r="4"></circle>
          <rect x="484" y="112" width="48" height="48" rx="4"></rect>
          <circle cx="508" cy="308" r="4"></circle>
          <circle cx="524" cy="308" r="4"></circle>
          <circle cx="540" cy="300" r="4"></circle>
          <circle cx="556" cy="308" r="4"></circle>
          <circle cx="684" cy="279" r="4"></circle>
          <circle cx="684" cy="303" r="4"></circle>
          <circle cx="672" cy="292" r="4"></circle>
          <circle cx="754" cy="111" r="4"></circle>
          <circle cx="256" cy="112" r="4"></circle>
          <rect x="2084" y="112" width="48" height="48" rx="4"></rect>
          <circle cx="2108" cy="308" r="4"></circle>
          <circle cx="2124" cy="308" r="4"></circle>
          <circle cx="2140" cy="300" r="4"></circle>
          <circle cx="2156" cy="308" r="4"></circle>
          <circle cx="2284" cy="279" r="4"></circle>
          <circle cx="2284" cy="303" r="4"></circle>
          <circle cx="2272" cy="292" r="4"></circle>
          <circle cx="2354" cy="111" r="4"></circle>
          <circle cx="1856" cy="112" r="4"></circle>
          <rect x="932" y="0" width="48" height="48" rx="4"></rect>
          <circle cx="972" cy="200" r="4"></circle>
          <circle cx="1000" cy="212" r="4"></circle>
          <circle cx="1028" cy="228" r="4"></circle>
          <circle cx="1056" cy="216" r="4"></circle>
          <circle cx="1008" cy="72" r="4"></circle>
          <rect x="992" y="132" width="40" height="40" rx="4"></rect>
          <circle cx="1268" cy="296" r="4"></circle>
          <circle cx="1471" cy="328" r="4"></circle>
          <circle cx="1444" cy="340" r="4"></circle>
          <circle cx="1504" cy="352" r="4"></circle>
          <circle cx="1012" cy="184" r="4"></circle>
          <circle cx="980" cy="168" r="4"></circle>
          <circle cx="980" cy="152" r="4"></circle>
          <circle cx="1072" cy="124" r="4"></circle>
          <circle cx="1044" cy="184" r="4"></circle>
          <circle cx="992" cy="104" r="4"></circle>
          <rect x="616" y="800" width="56" height="56" rx="4"></rect>
          <circle cx="755" cy="648" r="4"></circle>
          <circle cx="804" cy="729" r="4"></circle>
          <circle cx="817" cy="716" r="4"></circle>
          <circle cx="856" cy="716" r="4"></circle>
          <circle cx="884" cy="716" r="4"></circle>
          <circle cx="828" cy="729" r="4"></circle>
          <circle cx="771" cy="635" r="4"></circle>
          <circle cx="888" cy="904" r="4"></circle>
          <circle cx="831" cy="848" r="4"></circle>
          <circle cx="583" cy="868" r="4"></circle>
          <circle cx="656" cy="663" r="4"></circle>
          <circle cx="880" cy="615" r="4"></circle>
          <circle cx="869" cy="628" r="4"></circle>
          <circle cx="632" cy="741" r="4"></circle>
          <circle cx="620" cy="711" r="4"></circle>
          <circle cx="576" cy="820" r="4"></circle>
          <circle cx="576" cy="836" r="4"></circle>
          <circle cx="576" cy="852" r="4"></circle>
          <circle cx="559" cy="896" r="4"></circle>
          <circle cx="559" cy="919" r="4"></circle>
          <circle cx="571" cy="931" r="4"></circle>
          <circle cx="583" cy="943" r="4"></circle>
          <circle cx="672" cy="940" r="4"></circle>
          <circle cx="660" cy="928" r="4"></circle>
          <circle cx="547" cy="907" r="4"></circle>
          <rect x="1340" y="400" width="48" height="48" rx="4"></rect>
          <circle cx="1292" cy="440" r="4"></circle>
          <circle cx="1280" cy="452" r="4"></circle>
          <circle cx="1227" cy="360" r="4"></circle>
          <circle cx="1227" cy="383" r="4"></circle>
          <circle cx="1209" cy="371" r="4"></circle>
          <circle cx="1398" cy="371" r="4"></circle>
          <circle cx="1528" cy="408" r="4"></circle>
          <circle cx="1528" cy="424" r="4"></circle>
          <circle cx="1516" cy="436" r="4"></circle>
          <circle cx="1487" cy="436" r="4"></circle>
          <circle cx="1444" cy="452" r="4"></circle>
          <circle cx="1384" cy="519" r="4"></circle>
          <circle cx="1396" cy="508" r="4"></circle>
          <circle cx="1368" cy="519" r="4"></circle>
          <circle cx="1352" cy="519" r="4"></circle>
          <circle cx="1504" cy="447" r="4"></circle>
          <rect x="1340" y="1200" width="48" height="48" rx="4"></rect>
          <circle cx="1292" cy="1240" r="4"></circle>
          <circle cx="1280" cy="1252" r="4"></circle>
          <circle cx="1227" cy="1160" r="4"></circle>
          <circle cx="1227" cy="1183" r="4"></circle>
          <circle cx="1209" cy="1171" r="4"></circle>
          <circle cx="1398" cy="1171" r="4"></circle>
          <circle cx="1528" cy="1208" r="4"></circle>
          <circle cx="1528" cy="1224" r="4"></circle>
          <circle cx="1516" cy="1236" r="4"></circle>
          <circle cx="1487" cy="1236" r="4"></circle>
          <circle cx="1444" cy="1252" r="4"></circle>
          <circle cx="1384" cy="1319" r="4"></circle>
          <circle cx="1396" cy="1308" r="4"></circle>
          <circle cx="1368" cy="1319" r="4"></circle>
          <circle cx="1352" cy="1319" r="4"></circle>
          <circle cx="1504" cy="1247" r="4"></circle>
          <circle cx="1205" cy="662" r="4"></circle>
          <rect x="1124" y="820" width="48" height="48" rx="4"></rect>
          <circle cx="1173" cy="790" r="4"></circle>
          <circle cx="1175" cy="712" r="4"></circle>
          <circle cx="1132" cy="805" r="4"></circle>
          <circle cx="1148" cy="790" r="4"></circle>
          <circle cx="1120" cy="915" r="4"></circle>
          <circle cx="1169" cy="915" r="4"></circle>
          <circle cx="1133" cy="915" r="4"></circle>
          <circle cx="1185" cy="915" r="4"></circle>
          <path d="M1551.92188,500 L1571.99696,500 C1574.20778,500 1576,501.799795 1576,504.004908 L1576,551.995092 C1576,554.206941 1574.21305,556 1571.99388,556 L1552.22559,556 L1522.99753,556 C1520.78976,556 1519,554.200205 1519,551.995092 L1519,504.004908 L1519,504.004908 C1519,501.793059 1520.78859,500 1522.99321,500 L1551.8335,500"></path>
          <circle cx="1464" cy="211" r="4"></circle>
          <circle cx="1493" cy="220" r="4"></circle>
          <circle cx="1505" cy="231" r="4"></circle>
          <circle cx="1532" cy="263" r="4"></circle>
          <circle cx="1564" cy="172" r="4"></circle>
          <circle cx="1657" cy="411" r="4"></circle>
          <circle cx="1616" cy="572" r="4"></circle>
          <circle cx="1628" cy="476" r="4"></circle>
          <circle cx="1617" cy="487" r="4"></circle>
          <circle cx="1600" cy="572" r="4"></circle>
          <circle cx="1604" cy="476" r="4"></circle>
          <circle cx="1593" cy="487" r="4"></circle>
          <path d="M751.921875,1300 L771.996959,1300 C774.207777,1300 776,1301.7998 776,1304.00491 L776,1351.99509 C776,1354.20694 774.213055,1356 771.993879,1356 L752.225586,1356 L722.997534,1356 C720.789757,1356 719,1354.2002 719,1351.99509 L719,1304.00491 L719,1304.00491 C719,1301.79306 720.788588,1300 722.993206,1300 L751.833496,1300"></path>
          <circle cx="664" cy="1011" r="4"></circle>
          <circle cx="693" cy="1020" r="4"></circle>
          <circle cx="705" cy="1031" r="4"></circle>
          <circle cx="732" cy="1063" r="4"></circle>
          <circle cx="764" cy="972" r="4"></circle>
          <circle cx="857" cy="1211" r="4"></circle>
          <circle cx="816" cy="1372" r="4"></circle>
          <circle cx="828" cy="1276" r="4"></circle>
          <circle cx="817" cy="1287" r="4"></circle>
          <circle cx="800" cy="1372" r="4"></circle>
          <circle cx="804" cy="1276" r="4"></circle>
          <circle cx="793" cy="1287" r="4"></circle>
          <path d="M1492,744.030273 L1492,715.991893 L1492,715.991893 C1492,713.787232 1493.78429,712 1495.99005,712 L1512.00995,712 C1514.21359,712 1516,713.790092 1516,715.990494 L1516,744.019043"></path>
          <circle cx="1500" cy="696" r="4"></circle>
          <circle cx="1593" cy="715" r="4"></circle>
          <circle cx="1588" cy="691" r="4"></circle>
          <circle cx="1633" cy="707" r="4"></circle>
          <circle cx="1728" cy="684" r="4"></circle>
          <circle cx="1712" cy="719" r="4"></circle>
          <circle cx="1708" cy="607" r="4"></circle>
          <circle cx="1692" cy="603" r="4"></circle>
          <circle cx="1695" cy="656" r="4"></circle>
          <circle cx="1524" cy="784" r="4"></circle>
          <circle cx="1504" cy="784" r="4"></circle>
          <circle cx="1488" cy="784" r="4"></circle>
          <circle cx="1717" cy="839" r="4"></circle>
          <circle cx="1677" cy="884" r="4"></circle>
          <path d="M1516,744.15625 L1516,756.001953 C1516,758.210013 1514.21571,760 1512.00995,760 L1495.99005,760 C1493.78641,760 1492,758.210373 1492,755.995361 L1492,744.130127"></path>
          <rect x="992" y="932" width="40" height="40" rx="4"></rect>
          <circle cx="980" cy="968" r="4"></circle>
          <circle cx="1471" cy="1128" r="4"></circle>
          <circle cx="1444" cy="1140" r="4"></circle>
          <circle cx="1504" cy="1152" r="4"></circle>
          <circle cx="980" cy="952" r="4"></circle>
          <circle cx="1072" cy="924" r="4"></circle>
          <circle cx="1012" cy="984" r="4"></circle>
          <circle cx="1044" cy="984" r="4"></circle>
          <circle cx="992" cy="904" r="4"></circle>
          <rect x="2216" y="800" width="56" height="56" rx="4"></rect>
          <circle cx="2220" cy="711" r="4"></circle>
          <circle cx="2256" cy="663" r="4"></circle>
          <circle cx="2176" cy="820" r="4"></circle>
          <circle cx="2176" cy="836" r="4"></circle>
          <circle cx="2176" cy="852" r="4"></circle>
          <circle cx="2183" cy="868" r="4"></circle>
          <circle cx="2159" cy="896" r="4"></circle>
          <circle cx="2159" cy="919" r="4"></circle>
          <circle cx="2171" cy="931" r="4"></circle>
          <circle cx="2183" cy="943" r="4"></circle>
          <circle cx="2272" cy="940" r="4"></circle>
          <circle cx="2260" cy="928" r="4"></circle>
          <circle cx="2147" cy="907" r="4"></circle>
          <circle cx="2232" cy="741" r="4"></circle>
          <rect x="1804" y="1184" width="48" height="48" rx="4"></rect>
          <circle cx="1480" cy="863" r="4"></circle>
          <circle cx="1480" cy="895" r="4"></circle>
          <circle cx="1480" cy="911" r="4"></circle>
          <circle cx="2112" cy="1264" r="4"></circle>
          <circle cx="2027" cy="1204" r="4"></circle>
          <circle cx="1688" cy="867" r="4"></circle>
          <circle cx="1700" cy="855" r="4"></circle>
          <circle cx="1712" cy="867" r="4"></circle>
          <circle cx="1724" cy="855" r="4"></circle>
          <circle cx="1935" cy="1188" r="4"></circle>
          <circle cx="1939" cy="1168" r="4"></circle>
          <circle cx="1940" cy="1152" r="4"></circle>
          <circle cx="1892" cy="1184" r="4"></circle>
          <circle cx="1788" cy="1268" r="4"></circle>
          <circle cx="1796" cy="1136" r="4"></circle>
          <circle cx="1776" cy="1172" r="4"></circle>
          <circle cx="1824" cy="1296" r="4"></circle>
          <circle cx="1811" cy="1280" r="4"></circle>
        </g>

        <g
          id="paths-bg"
          transform="translate(0.000000, 0.000000)"
          stroke="#DDE0E2"
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g id="C23" transform="translate(176.000000, 0.000000)">
            <polyline id="path" points="52 92 84 92 116 60 116 0"></polyline>
            <polyline id="path" points="52 84 80 84 108 56 108 0"></polyline>
            <polyline id="path" points="52 76 76 76 100 52 100 0"></polyline>
            <polyline id="path" points="52 68 72 68 92 48 92 0"></polyline>
            <polyline id="path" points="52 60 68 60 84 44 84 0"></polyline>
            <path d="M16,56 L16,0" id="path"></path>
            <path d="M8,56 L8,0" id="path"></path>
            <path d="M24,56 L24,0" id="path"></path>
            <path d="M32,56 L32,0" id="path"></path>
            <path d="M40,56 L40,0" id="path"></path>
            <path d="M48,56 L48,0" id="path"></path>
            <path d="M0,92 L4,92" id="path"></path>
            <polyline
              id="path"
              points="52 100 56 100 72 100 80.0156098 108.01561 80.0156098 124.007338"
            ></polyline>
            <path d="M0,100 L4,100" id="path"></path>
            <path d="M0,84 L4,84" id="path"></path>
            <path d="M0,76 L4,76" id="path"></path>
            <path d="M0,68 L4,68" id="path"></path>
            <path d="M0,60 L4,60" id="path"></path>
            <polyline
              id="path"
              points="96 284 88 284 84 288 32 288 16 272 16 108 16 104"
            ></polyline>
            <polyline
              id="path"
              points="104 439 104 372 8 276 8 108 8 104"
            ></polyline>
            <polyline
              id="path"
              points="124 272 88 272 80 280 36 280 24 268 24 108 24 104"
            ></polyline>
            <polyline
              id="path"
              points="68 268 36 268 32 264 32 108 32 104"
            ></polyline>
            <polyline
              id="path"
              points="44.0311289 252.000061 44.0311289 244.031129 40 240 40 108 40 104"
            ></polyline>
            <polyline
              id="path"
              points="48 108 48 104 48 184 56 192 60 192 64 192"
            ></polyline>
          </g>
          <g id="C22" transform="translate(-1.000000, 239.000000)">
            <polyline
              id="path"
              points="1 0 25 0 57 32 57 156 69 168 69 172"
            ></polyline>
            <polyline
              id="path"
              points="1 8 21 8 50 37 50 161 53 164 53 172"
            ></polyline>
            <polyline
              id="path"
              points="1 32 8 32 24 48 24 169 12.954639 180.045361 13 248 13 257 0 270"
            ></polyline>
            <polyline
              id="path"
              points="0 282 21 261 21 185 33 173 33 45 12 24 1 24"
            ></polyline>
            <polyline
              id="path"
              points="0 317 0 293 29 264 29 189 41 177 41 40 17 16 1 16"
            ></polyline>
          </g>
          <g id="C21" transform="translate(0.000000, 115.000000)">
            <polyline
              id="path"
              points="300 361 360 361 376.03122 344.96878 424 344.96878 471.000005 344.96878"
            ></polyline>
            <polyline
              id="path"
              points="0 41 76 41 120 85 120 201 156 237 176 237 208 269 208 285 196 297 196 337 228 369 252 369"
            ></polyline>
            <polyline
              id="path"
              points="300 369 391 369 395 365 464 365 468 361 476 361 520 405 556 405"
            ></polyline>
            <polyline
              id="path"
              points="300 353 356 353 372 337 376 337 380 333"
            ></polyline>
            <polyline
              id="path"
              points="0 17 88 17 144 73 144 181 224 261 224 293 212 305 212 329 236 353 252 353"
            ></polyline>
            <polyline id="path" points="300 345 352 345 384 313"></polyline>
            <polyline
              id="path"
              points="224 317 224 329 240 345 252 345"
            ></polyline>
            <polyline
              id="path"
              points="300 337 347 337 376 308 376 305 385 296"
            ></polyline>
            <polyline
              id="path"
              points="136 12 136 21 152 37 152 177 232 257 232 293 236 297 236 329 244 337 252 337"
            ></polyline>
            <polyline
              id="path"
              points="300 329 316 329 320 325 336 325"
            ></polyline>
            <polyline
              id="path"
              points="348 597 328 597 304 573 304 409 296 401 296 373"
            ></polyline>
            <polyline
              id="path"
              points="244 281 244 325 248 329 252 329"
            ></polyline>
            <polyline
              id="path"
              points="264 325 264 265 168 169 168 29 160 21 160 12"
            ></polyline>
            <polyline
              id="path"
              points="260 489 259.984385 441.015635 247.96878 429.000031 247.96878 413.03122 264 397 264 373"
            ></polyline>
            <polyline
              id="path"
              points="256 325 256 269 160 173 160 33 148 21 148 0"
            ></polyline>
            <polyline id="path" points="239 406 256 389 256 373"></polyline>
            <polyline
              id="path"
              points="272 325 272 261 176 165 176 25 172 21 172 1"
            ></polyline>
            <polyline
              id="path"
              points="259 417 259 414 272 401 272 373"
            ></polyline>
            <polyline
              id="path"
              points="272 433 272 413 280 405 280 373"
            ></polyline>
            <polyline
              id="path"
              points="288 325 288 237 304 221 304 212"
            ></polyline>
            <polyline
              id="path"
              points="348 605 323 605 296 578 296 414 288 406 288 373"
            ></polyline>
            <polyline
              id="path"
              points="296 325 296 241 316 221 316 201"
            ></polyline>
            <polyline
              id="path"
              points="0 33 79.9895845 32.9895845 128 81 128 197 144 213 164 213 216 265 216 289 204 301.285714 204 333.571429 231.428571 361 252 361"
            ></polyline>
          </g>
          <g id="C20" transform="translate(0.000000, 622.000000)">
            <polyline id="path" points="0 21 88 21 101 8 101 1"></polyline>
            <polyline
              id="path"
              points="0 29 93 29 117.020824 4.9791757 117.020824 0.99994551"
            ></polyline>
            <polyline id="path" points="0 37 96 37 133 0"></polyline>
            <polyline
              id="path"
              points="0 53 4 53 12 44.9377423 100 45 135 10 143 10 152 1"
            ></polyline>
            <polyline
              id="path"
              points="0 61 9 61 17 53 104 53 140 17 164 17"
            ></polyline>
          </g>
          <g id="C19" transform="translate(1532.000000, 115.000000)">
            <polyline
              id="path"
              points="368 361 428 361 444.03122 344.96878 492 344.96878 539.000005 344.96878"
            ></polyline>
            <polyline
              id="path"
              points="0 52 12 52 23 41 68 41 144 41 188 85 188 201 224 237 244 237 276 269 276 285 264 297 264 337 296 369 320 369"
            ></polyline>
            <polyline
              id="path"
              points="368 369 459 369 463 365 532 365 536 361 544 361 588 405 624 405"
            ></polyline>
            <polyline
              id="path"
              points="368 353 424 353 440 337 444 337 448 333"
            ></polyline>
            <polyline
              id="path"
              points="0 4 4 4 17 17 68 17 156 17 212 73 212 181 292 261 292 293 280 305 280 329 304 353 320 353"
            ></polyline>
            <polyline id="path" points="368 345 420 345 452 313"></polyline>
            <polyline
              id="path"
              points="292 317 292 329 308 345 320 345"
            ></polyline>
            <polyline
              id="path"
              points="368 337 415 337 444 308 444 305 453 296"
            ></polyline>
            <polyline
              id="path"
              points="204 12 204 21 220 37 220 177 300 257 300 293 304 297 304 329 312 337 320 337"
            ></polyline>
            <polyline
              id="path"
              points="368 329 384 329 388 325 404 325"
            ></polyline>
            <polyline
              id="path"
              points="416 597 396 597 372 573 372 409 364 401 364 373"
            ></polyline>
            <polyline
              id="path"
              points="312 281 312 325 316 329 320 329"
            ></polyline>
            <polyline
              id="path"
              points="332 325 332 265 236 169 236 29 228 21 228 12"
            ></polyline>
            <polyline
              id="path"
              points="328 489 327.984385 441.015635 315.96878 429.000031 315.96878 413.03122 332 397 332 373"
            ></polyline>
            <polyline
              id="path"
              points="324 325 324 269 228 173 228 33 216 21 216 0"
            ></polyline>
            <polyline id="path" points="307 406 324 389 324 373"></polyline>
            <polyline
              id="path"
              points="340 325 340 261 244 165 244 25 240 21 240 1"
            ></polyline>
            <polyline
              id="path"
              points="327 417 327 414 340 401 340 373"
            ></polyline>
            <polyline
              id="path"
              points="340 433 340 413 348 405 348 373"
            ></polyline>
            <polyline
              id="path"
              points="356 325 356 237 372 221 372 212"
            ></polyline>
            <polyline
              id="path"
              points="416 605 391 605 364 578 364 414 356 406 356 373"
            ></polyline>
            <polyline
              id="path"
              points="364 325 364 241 384 221 384 201"
            ></polyline>
            <polyline
              id="path"
              points="0 36 17 36 20 33 68 33 147.989584 32.9895845 196 81 196 197 212 213 232 213 284 265 284 289 272 301.285714 272 333.571429 299.428571 361 320 361"
            ></polyline>
          </g>
          <g id="C18" transform="translate(0.000000, 771.000000)">
            <polyline
              id="Path-4-Copy-466"
              points="0 137 60 137 100 97 100 29 100 20 119.026298 0.97370241 128.058497 0.97370241"
            ></polyline>
            <polyline
              id="Path-4-Copy-467"
              points="0 129 42 129 56 129 92 93 92 29 92 13 100.513149 4.4868512"
            ></polyline>
            <polyline
              id="Path-4-Copy-468"
              points="0 121 42 121 53 121 85 89 85 42 76 33 76 29 76 19"
            ></polyline>
            <polyline
              id="Path-4-Copy-469"
              points="0 113 42 113 47 113 75 85 75 43 65 33 65 29 65 5"
            ></polyline>
            <polyline
              id="Path-4-Copy-470"
              points="0 105 42 105 44 105 68 81 68 49 52 33 52 29 52 19"
            ></polyline>
            <polyline
              id="Path-4-Copy-165"
              points="0 145 67 145 76 136"
            ></polyline>
          </g>
          <g id="C17" transform="translate(216.000000, 519.000000)">
            <path d="M188,201 L203,201" id="path"></path>
            <polyline
              id="path"
              points="23 48 28 53 28 73 16 85 16 117 64 165 64 181 100 217 132 217"
            ></polyline>
            <path d="M188,217 L203,217" id="path"></path>
            <polyline
              id="path"
              points="50.976204 135.999929 50.976204 139.976204 72 161 72 177 104 209 132 209"
            ></polyline>
            <polyline
              id="path"
              points="0 48.9934213 0 125 48 173 48 189 92 233 132 233"
            ></polyline>
            <path d="M188,233 L203,233" id="path"></path>
            <polyline
              id="path"
              points="13 68 8 73 8 121 56 169 56 185 96 225 132 225"
            ></polyline>
            <polyline
              id="path"
              points="139 185 139 169 107 137 107 105 99 97 99 45"
            ></polyline>
            <polyline
              id="path"
              points="41 445 41 427 52 416 52 377 140 289 140 281 140 241"
            ></polyline>
            <polyline
              id="path"
              points="53 433 53 428 61 420 61 380 148 293 148 281 148 241"
            ></polyline>
            <polyline
              id="path"
              points="65 445 65 428 69 424 69 384 156 296 156 281 156 241"
            ></polyline>
            <polyline
              id="path"
              points="77 433 77 388 164 301 164 281 164 241"
            ></polyline>
            <polyline
              id="path"
              points="125 428 125 424 129 420 129 348 172 305 172 281 172 241"
            ></polyline>
            <polyline
              id="path"
              points="136 448 136 353 180 309 180 281 180 241"
            ></polyline>
            <path d="M188,193 L193,193" id="path"></path>
            <path d="M188,209 L193,209" id="path"></path>
            <path d="M188,225 L193,225" id="path"></path>
            <polyline
              id="path"
              points="155 185 155 161 124 130 124 46"
            ></polyline>
            <polyline
              id="path"
              points="147 185 147 164 116 133 116 89 112 85 112 57.9814878"
            ></polyline>
            <polyline
              id="path"
              points="163 185 163 156 132 125 132 85 140 77 140 45"
            ></polyline>
            <polyline
              id="path"
              points="171 185 171 153 140 122 140 88.984852 147.99243 80.9924224 147.99243 48.9999991 168.021383 28.9710453 200.000013 28.9710453 227.985533 0.985525461 244.000007 0.985525461 300.007241 56.9927599 316.000002 56.9927599 324.059116 48.9336452 336.000184 48.9336452"
            ></polyline>
            <polyline
              id="path"
              points="179 185 179 149 148 118 148 92 156 84 156 61 169 48"
            ></polyline>
          </g>
          <g id="C16" transform="translate(165.000000, 539.000000)">
            <polyline
              id="paths"
              points="43 317 43 261 43 240 72 211 72 173 68 169 68 156"
            ></polyline>
            <polyline
              id="paths"
              points="27 317 27 261 27 232 51 208 51 205"
            ></polyline>
            <polyline
              id="paths"
              points="59 317 59 261 59 248 88.0172363 218.982764 88.0172363 207.999986 92.1298907 203.887332 92.1298907 197"
            ></polyline>
            <polyline
              id="paths"
              points="51 317 51 261 51 244 80 215 80 168"
            ></polyline>
            <polyline
              id="paths"
              points="35 317 35 261 35 237 64 208 64 177 51 164 51 129 35 113 35 45 0 10 0 0"
            ></polyline>
            <polyline
              id="paths"
              points="19 317 19 261 19 229 36 212 36 137 16 117 16 88"
            ></polyline>
            <polyline
              id="paths"
              points="63 361 67 361 83 361 91.0156098 369.01561 91.0156098 385.007338"
            ></polyline>
            <polyline
              id="paths"
              points="59 369 59 365 59 445 67 453 71 453 75 453"
            ></polyline>
            <polyline
              id="paths"
              points="107 545 99 545 95 549 43 549 27 533 27 369 27 365"
            ></polyline>
            <polyline
              id="paths"
              points="79 529 47 529 43 525 43 369 43 365"
            ></polyline>
            <polyline
              id="paths"
              points="63 353 95 353 127 321 127 261 127 249 144 232"
            ></polyline>
            <polyline
              id="paths"
              points="63 345 91 345 119 317 119 261 119 241 129 231"
            ></polyline>
            <polyline
              id="paths"
              points="63 337 87 337 111 313 111 261 111 232"
            ></polyline>
            <polyline
              id="paths"
              points="63 329 83 329 103 309 103 261 103 252 99 248 99 244"
            ></polyline>
            <polyline
              id="paths"
              points="63 321 79 321 95 305 95 261 95 256 91 252"
            ></polyline>
            <polyline
              id="paths"
              points="115 700 115 633 19 537 19 369 19 365"
            ></polyline>
            <polyline
              id="paths"
              points="135 533 99 533 91 541 47 541 35 529 35 369 35 365"
            ></polyline>
            <polyline
              id="paths"
              points="55.0311289 513.000061 55.0311289 505.031129 51 501 51 369 51 365"
            ></polyline>
          </g>
          <g id="C15" transform="translate(1765.000000, 539.000000)">
            <polyline
              id="path"
              points="43 317 43 261 43 240 72 211 72 173 68 169 68 156"
            ></polyline>
            <polyline
              id="path"
              points="27 317 27 261 27 232 51 208 51 205"
            ></polyline>
            <polyline
              id="path"
              points="59 317 59 261 59 248 88.0172363 218.982764 88.0172363 207.999986 92.1298907 203.887332 92.1298907 197"
            ></polyline>
            <polyline
              id="path"
              points="51 317 51 261 51 244 80 215 80 168"
            ></polyline>
            <polyline
              id="path"
              points="35 317 35 261 35 237 64 208 64 177 51 164 51 129 35 113 35 45 0 10 0 0"
            ></polyline>
            <polyline
              id="path"
              points="19 317 19 261 19 229 36 212 36 137 16 117 16 88"
            ></polyline>
            <polyline
              id="path"
              points="63 361 67 361 83 361 91.0156098 369.01561 91.0156098 385.007338"
            ></polyline>
            <polyline
              id="path"
              points="59 369 59 365 59 445 67 453 71 453 75 453"
            ></polyline>
            <polyline
              id="path"
              points="107 545 99 545 95 549 43 549 27 533 27 369 27 365"
            ></polyline>
            <polyline
              id="path"
              points="79 529 47 529 43 525 43 369 43 365"
            ></polyline>
            <polyline
              id="path"
              points="63 353 95 353 127 321 127 261 127 249 144 232"
            ></polyline>
            <polyline
              id="path"
              points="63 345 91 345 119 317 119 261 119 241 129 231"
            ></polyline>
            <polyline
              id="path"
              points="63 337 87 337 111 313 111 261 111 232"
            ></polyline>
            <polyline
              id="path"
              points="63 329 83 329 103 309 103 261 103 252 99 248 99 244"
            ></polyline>
            <polyline
              id="path"
              points="63 321 79 321 95 305 95 261 95 256 91 252"
            ></polyline>
            <polyline
              id="path"
              points="115 700 115 633 19 537 19 369 19 365"
            ></polyline>
            <polyline
              id="path"
              points="135 533 99 533 91 541 47 541 35 529 35 369 35 365"
            ></polyline>
            <polyline
              id="path"
              points="55.0311289 513.000061 55.0311289 505.031129 51 501 51 369 51 365"
            ></polyline>
          </g>
          <g id="C14" transform="translate(308.000000, 0.000000)">
            <polyline
              id="path"
              points="272 196 288 196 300 208 300 224 324 248 416 248 421 243 428 243"
            ></polyline>
            <polyline
              id="path"
              points="272 188 292 188 308 204 308 220 328 240 412.005952 240 420.002977 232.002976 480 232.002976 493.001488 219.001488 494 218 494 171"
            ></polyline>
            <path d="M272,180 L284,180" id="path"></path>
            <path d="M272,172 L284,172" id="path"></path>
            <polyline
              id="path"
              points="380.05579 370.996531 371.003473 370.996531 368.000001 367.993058 324.006943 367.993058 296.013886 340.000001 296.013886 267.013886 260 231 260 216"
            ></polyline>
            <polyline
              id="path"
              points="-2.52347418e-05 167.966704 20.9667036 167.966704 36 183 136 183 165 212 224 212"
            ></polyline>
            <polyline
              id="path"
              points="272 212 280 212 284 216 284 232 312 260 312 296 368 352 396 352 400 348 408 348"
            ></polyline>
            <polyline
              id="path"
              points="272 204 284 204 292 212 292 227 320 255 320 292.013511 371.993245 344.006756 392.02464 344.006756 401.069416 334.96198 420.000038 334.96198"
            ></polyline>
            <polyline
              id="path"
              points="248 360 248 356 265 339 265 320 248 303 248 267 228 247 228 216"
            ></polyline>
            <polyline
              id="path"
              points="280 352 280 276 244 240 244 216"
            ></polyline>
            <polyline id="path" points="223 196 172 196 144 168 144 0"></polyline>
            <polyline id="path" points="236 168 236 148 272 112 272 0"></polyline>
            <polyline id="path" points="224 204 169 204 136 171 136 0"></polyline>
            <polyline id="path" points="228 167 228 144 264 108 264 0"></polyline>
            <polyline
              id="path"
              points="264.003967 360.000001 264.003967 351.003969 272 343.007936 272 280 236 244 236 216"
            ></polyline>
            <polyline
              id="path"
              points="295.996576 360.000001 295.996576 352.003425 288 344.006849 288 271 252 235 252 216"
            ></polyline>
            <path
              d="M420.005435,359 L328,359 L304,335 L304,264 L268,228 L268,216"
              id="path"
            ></path>
            <polyline
              id="path"
              points="224.010169 188.022424 177.017751 188.022424 152 163.004673 152 56 152 0"
            ></polyline>
            <polyline id="path" points="244 168 244 152 280 116 280 0"></polyline>
            <polyline id="path" points="224 180 181 180 160 159 160 0"></polyline>
            <polyline id="path" points="252 168 252 156 288 120 288 0"></polyline>
            <polyline id="path" points="224 172 185 172 168 155 168 0"></polyline>
            <polyline id="path" points="260 168 260 160 296 124 296 0"></polyline>
            <polyline id="path" points="268 168 268 164 304 128 304 0"></polyline>
          </g>
          <g id="C13" transform="translate(1908.000000, 0.000000)">
            <polyline
              id="path"
              points="272 196 288 196 300 208 300 224 324 248 416 248 421 243 428 243"
            ></polyline>
            <polyline
              id="path"
              points="272 188 292 188 308 204 308 220 328 240 412.005952 240 420.002977 232.002976 480 232.002976 493.001488 219.001488 494 218 494 171"
            ></polyline>
            <path d="M272,180 L284,180" id="path"></path>
            <path d="M272,172 L284,172" id="path"></path>
            <polyline
              id="path"
              points="380.05579 370.996531 371.003473 370.996531 368.000001 367.993058 324.006943 367.993058 296.013886 340.000001 296.013886 267.013886 260 231 260 216"
            ></polyline>
            <polyline
              id="path"
              points="-2.52347418e-05 167.966704 20.9667036 167.966704 36 183 136 183 165 212 224 212"
            ></polyline>
            <polyline
              id="path"
              points="272 212 280 212 284 216 284 232 312 260 312 296 368 352 396 352 400 348 408 348"
            ></polyline>
            <polyline
              id="path"
              points="272 204 284 204 292 212 292 227 320 255 320 292.013511 371.993245 344.006756 392.02464 344.006756 401.069416 334.96198 420.000038 334.96198"
            ></polyline>
            <polyline
              id="path"
              points="248 360 248 356 265 339 265 320 248 303 248 267 228 247 228 216"
            ></polyline>
            <polyline
              id="path"
              points="280 352 280 276 244 240 244 216"
            ></polyline>
            <polyline id="path" points="223 196 172 196 144 168 144 0"></polyline>
            <polyline id="path" points="236 168 236 148 272 112 272 0"></polyline>
            <polyline id="path" points="224 204 169 204 136 171 136 0"></polyline>
            <polyline id="path" points="228 167 228 144 264 108 264 0"></polyline>
            <polyline
              id="path"
              points="264.003967 360.000001 264.003967 351.003969 272 343.007936 272 280 236 244 236 216"
            ></polyline>
            <polyline
              id="path"
              points="295.996576 360.000001 295.996576 352.003425 288 344.006849 288 271 252 235 252 216"
            ></polyline>
            <path
              d="M420.005435,359 L328,359 L304,335 L304,264 L268,228 L268,216"
              id="path"
            ></path>
            <polyline
              id="path"
              points="224.010169 188.022424 177.017751 188.022424 152 163.004673 152 56 152 0"
            ></polyline>
            <polyline id="path" points="244 168 244 152 280 116 280 0"></polyline>
            <polyline id="path" points="224 180 181 180 160 159 160 0"></polyline>
            <polyline id="path" points="252 168 252 156 288 120 288 0"></polyline>
            <polyline id="path" points="224 172 185 172 168 155 168 0"></polyline>
            <polyline id="path" points="260 168 260 160 296 124 296 0"></polyline>
            <polyline id="path" points="268 168 268 164 304 128 304 0"></polyline>
          </g>
          <g id="C12" transform="translate(976.000000, 0.000000)">
            <polyline id="path" points="52 92 84 92 116 60 116 0"></polyline>
            <polyline id="path" points="52 84 80 84 108 56 108 0"></polyline>
            <polyline id="path" points="52 76 76 76 100 52 100 0"></polyline>
            <polyline id="path" points="52 68 72 68 92 48 92 0"></polyline>
            <polyline id="path" points="52 60 68 60 84 44 84 0"></polyline>
            <path d="M16,56 L16,0" id="path"></path>
            <path d="M8,56 L8,0" id="path"></path>
            <path d="M24,56 L24,0" id="path"></path>
            <path d="M32,56 L32,0" id="path"></path>
            <path d="M40,56 L40,0" id="path"></path>
            <path d="M48,56 L48,0" id="path"></path>
            <path d="M0,92 L4,92" id="path"></path>
            <polyline
              id="path"
              points="52 100 56 100 72 100 80.0156098 108.01561 80.0156098 124.007338"
            ></polyline>
            <path d="M0,100 L4,100" id="path"></path>
            <path d="M0,84 L4,84" id="path"></path>
            <path d="M0,76 L4,76" id="path"></path>
            <path d="M0,68 L4,68" id="path"></path>
            <path d="M0,60 L4,60" id="path"></path>
            <polyline
              id="path"
              points="96 284 88 284 84 288 32 288 16 272 16 108 16 104"
            ></polyline>
            <polyline
              id="path"
              points="104 439 104 372 8 276 8 108 8 104"
            ></polyline>
            <polyline
              id="path"
              points="124 272 88 272 80 280 36 280 24 268 24 108 24 104"
            ></polyline>
            <polyline
              id="path"
              points="68 268 36 268 32 264 32 108 32 104"
            ></polyline>
            <polyline
              id="path"
              points="44.0311289 252.000061 44.0311289 244.031129 40 240 40 108 40 104"
            ></polyline>
            <polyline
              id="path"
              points="48 108 48 104 48 184 56 192 60 192 64 192"
            ></polyline>
          </g>
          <g id="C11" transform="translate(1032.000000, 164.000000)">
            <polyline
              id="path"
              points="48 52 195 52 228 85 228 176 300 248 372 248 392 228 432 228 464 260 516 260 520 256 520 248"
            ></polyline>
            <polyline
              id="path"
              points="48 44 199 44 235 80 235 171.005494 283.997253 220.002747 436 220.002747 448.040112 232.042859 455.065506 232.042859"
            ></polyline>
            <polyline
              id="path"
              points="48 36 203 36 244 77 244 168 288 212 439 212 447 220 482 220"
            ></polyline>
            <path
              d="M48,28 L207,28 L252,73 L252,164 C252,164 267,180 268,180 L276,180 L281,185"
              id="path"
            ></path>
            <path d="M0,60 L8,60" id="path"></path>
            <path d="M4,52 L8,52" id="path"></path>
            <path d="M0,44 L8,44" id="path"></path>
            <path d="M4,36 L8,36" id="path"></path>
            <path d="M28,72 L28,64" id="path"></path>
            <polyline id="path" points="44 24 44 20 48 16 84 16"></polyline>
            <polyline id="path" points="56 76 52 76 44 68 44 64"></polyline>
            <path d="M20,24 L20,20" id="path"></path>
            <path d="M28,24 L28,20" id="path"></path>
            <polyline id="path" points="12 24 12 20 8 16 8 0"></polyline>
            <path d="M36,24 L36,20" id="path"></path>
          </g>
          <g id="C10" transform="translate(599.000000, 675.000000)">
            <polyline id="path" points="29 153 29 181 49 201 65 201"></polyline>
            <polyline
              id="path"
              points="121 201 153 201 169 217 201 217 243 217 254 217 286 185 286 138 277 129 277 125 277 115"
            ></polyline>
            <polyline id="path" points="45 153 45 173 57 185 65 185"></polyline>
            <polyline
              id="path"
              points="121 185 161.012498 185 177.00625 200.993752 201 200.993752 243 201 245 201 269 177 269 145 253 129 253 125 253 115"
            ></polyline>
            <polyline
              id="path"
              points="121 217 145 217 161 233 201 233 261 233 301 193 301 125 301 116 320.026298 96.9737024 329.058497 96.9737024"
            ></polyline>
            <polyline
              id="path"
              points="121 209 149 209 165 225 201 225 243 225 257 225 293 189 293 125 293 109 301.513149 100.486851"
            ></polyline>
            <polyline
              id="path"
              points="121 193 157 193 173 209 201 209 243 209 248 209 276 181 276 139 266 129 266 125 266 101"
            ></polyline>
            <polyline
              id="path"
              points="109 181 109 157 117 149 117 124.979176 117 77 138.023796 55.976204 182.000006 55.976204 196.98811 40.9881005 201.000018 40.9881005 213 41 217 37 309 37 318 28 318 13"
            ></polyline>
            <polyline
              id="path"
              points="117 181 117 161 125 153 125 125 125 81 142 64 185.011626 64 200.005814 49.005812 201 49.005812 217 49 221 45 314 45 326 33 326 24 329 21 329 0"
            ></polyline>
            <polyline
              id="path"
              points="93 181 93 149 101 141 101 124.96878 101 69 130 40 173 40 197 16 201 16 216 16"
            ></polyline>
            <polyline
              id="path"
              points="121 225 141 225 157 241 201 241 268 241 277 232"
            ></polyline>
            <polyline
              id="path"
              points="121 233 137 233 153 249 201 249 293 249 321 277 329 277 334 282"
            ></polyline>
            <polyline id="path" points="37 153 37 177 53 193 65 193"></polyline>
            <polyline id="path" points="35 246 48 233 65 233"></polyline>
            <polyline id="path" points="69 181 69 125 69 96"></polyline>
            <polyline
              id="path"
              points="23.9999921 311.98812 32.9880842 311.98812 36.976204 308 58 308 93 273 93 237"
            ></polyline>
            <polyline
              id="path"
              points="85 181 85 145 93 137 93 125 93 57 102 48"
            ></polyline>
            <polyline
              id="path"
              points="101 181 101 153 109 145 109 125 109 74 134 49 177 49 197 29 200 29"
            ></polyline>
            <path d="M29,216.666667 L65,216.666667" id="path"></path>
            <polyline id="path" points="29 201 37 201 45 209 65 209"></polyline>
            <polyline id="path" points="29 233 37 233 45 225 65 225"></polyline>
            <polyline
              id="path"
              points="12 277 21 277 29 285 45 285 69 261 69 237"
            ></polyline>
            <polyline
              id="path"
              points="120.996096 317.000001 120.996096 305.003908 117 301.007812 117 237"
            ></polyline>
            <polyline
              id="path"
              points="11.9878067 300 53 300 85 268 85 237"
            ></polyline>
            <polyline id="path" points="77 181 77 141 81 137 81 126"></polyline>
            <polyline
              id="path"
              points="0 288 20 288 24 292 49 292 77 264 77 237"
            ></polyline>
            <polyline
              id="path"
              points="35.9999987 324.003205 41.0032034 324.003205 48.9999983 316.00641 61.0064087 316.00641 101 276.012818 101 237"
            ></polyline>
            <path d="M108.666667,305.029405 L108.666667,237" id="path"></path>
          </g>
          <g id="C9" transform="translate(1261.000000, 416.000000)">
            <path d="M135,39 L135,27" id="path"></path>
            <path d="M151,39 L151,27" id="path"></path>
            <path d="M143,39 L143,27" id="path"></path>
            <polyline
              id="path"
              points="18 0 27 0 55 28 95 28 115 48 127 48"
            ></polyline>
            <polyline id="path" points="175 48 287 48 303 64 311 64"></polyline>
            <polyline
              id="path"
              points="18 23 27 23 47 43 86 43 107 64 127 64"
            ></polyline>
            <polyline
              id="path"
              points="175 64 279 64 291.041595 76.0415946 291.041595 83.0001243"
            ></polyline>
            <polyline
              id="path"
              points="-8.03677904e-06 10.9791757 26.9791757 10.9791757 51 35 90 35 111 56 127 56"
            ></polyline>
            <polyline
              id="path"
              points="175 56 283.00463 56 300.002315 72.9976854"
            ></polyline>
            <polyline id="path" points="72 92 98 92 110 80 127 80"></polyline>
            <polyline
              id="path"
              points="175 80 187 80 203 96 211 96 215 92 227 92"
            ></polyline>
            <polyline id="path" points="84 80 99 80 107 72 127 72"></polyline>
            <polyline id="path" points="175 72 259 72 263 76 270 76"></polyline>
            <polyline
              id="path"
              points="139.02077 155.000054 139.02077 151.020824 147.041595 143 147.041595 128.041595 135 116 135 88"
            ></polyline>
            <polyline
              id="path"
              points="162 147 162 119 151 108 151 88"
            ></polyline>
            <polyline
              id="path"
              points="155 155 155 124 143 112 143 88"
            ></polyline>
            <polyline id="path" points="159 39 159 27 175 11 181 11"></polyline>
            <polyline
              id="path"
              points="171 155 171 116 159 104 159 88"
            ></polyline>
            <polyline
              id="path"
              points="167 39 167 32 176 23 203 23 219 39 290 39 299 48 311 48"
            ></polyline>
            <polyline
              id="path"
              points="183 144 183 136 179 132 179 111 167 99 167 88"
            ></polyline>
          </g>
          <g id="C8" transform="translate(1261.000000, 1216.000000)">
            <path d="M135,39 L135,27" id="path"></path>
            <path d="M151,39 L151,27" id="path"></path>
            <path d="M143,39 L143,27" id="path"></path>
            <polyline
              id="path"
              points="18 0 27 0 55 28 95 28 115 48 127 48"
            ></polyline>
            <polyline id="path" points="175 48 287 48 303 64 311 64"></polyline>
            <polyline
              id="path"
              points="18 23 27 23 47 43 86 43 107 64 127 64"
            ></polyline>
            <polyline
              id="path"
              points="175 64 279 64 291.041595 76.0415946 291.041595 83.0001243"
            ></polyline>
            <polyline
              id="path"
              points="-8.03677904e-06 10.9791757 26.9791757 10.9791757 51 35 90 35 111 56 127 56"
            ></polyline>
            <polyline
              id="path"
              points="175 56 283.00463 56 300.002315 72.9976854"
            ></polyline>
            <polyline id="path" points="72 92 98 92 110 80 127 80"></polyline>
            <polyline
              id="path"
              points="175 80 187 80 203 96 211 96 215 92 227 92"
            ></polyline>
            <polyline id="path" points="84 80 99 80 107 72 127 72"></polyline>
            <polyline id="path" points="175 72 259 72 263 76 270 76"></polyline>
            <polyline
              id="path"
              points="139.02077 155.000054 139.02077 151.020824 147.041595 143 147.041595 128.041595 135 116 135 88"
            ></polyline>
            <polyline
              id="path"
              points="162 147 162 119 151 108 151 88"
            ></polyline>
            <polyline
              id="path"
              points="155 155 155 124 143 112 143 88"
            ></polyline>
            <polyline id="path" points="159 39 159 27 175 11 181 11"></polyline>
            <polyline
              id="path"
              points="171 155 171 116 159 104 159 88"
            ></polyline>
            <polyline
              id="path"
              points="167 39 167 32 176 23 203 23 219 39 290 39 299 48 311 48"
            ></polyline>
            <polyline
              id="path"
              points="183 144 183 136 179 132 179 111 167 99 167 88"
            ></polyline>
          </g>
          <g id="C7" transform="translate(1168.000000, 722.000000)">
            <polyline
              id="path"
              points="53 162 61 162 68 154 68 114 52 98 52 78 52 74 69 57 69 24 85 8 85 0"
            ></polyline>
            <path d="M12,154 L12,144" id="path"></path>
            <polyline id="path" points="0 245 0 230 12 218 12 202"></polyline>
            <polyline id="path" points="13 245 13 229 20 222 20 202"></polyline>
            <path d="M28,154 L28,128" id="path"></path>
            <polyline id="path" points="49 245 49 237 28 216 28 202"></polyline>
            <polyline id="path" points="44 154 44 145 53 136 53 128"></polyline>
            <polyline id="path" points="65 245 65 229 44 209 44 202"></polyline>
            <polyline id="path" points="36 153 36 78 36 65 52 49"></polyline>
          </g>
          <g id="C6" transform="translate(1515.000000, 227.000000)">
            <polyline
              id="path"
              points="59 329 59 295 86.5045451 267.495455 89 265 89 194 86 191 61 166 61 105 65 101 65 96"
            ></polyline>
            <polyline
              id="path"
              points="75 329 75 303 88.0384048 289.961595 105 273 105 197 117 185 117 57 96 36 85 36 70 36 61 45 41 45 37 49 30 49"
            ></polyline>
            <polyline
              id="path"
              points="67 329 67 299 87.0249844 278.975016 97 269 97 260 96.954639 192.045361 108 181 108 60 92 44 85 44 73 44 64.9377423 52.0622577 52.9998377 52.0622577 45.0309872 60.0311082 41.9998404 60.0311082"
            ></polyline>
            <polyline
              id="path"
              points="0.96159519 40 14 40 17 37 56 37 65 28 85 28 101 28 125 52 125 189 113 201 113 276 84 305 84 329"
            ></polyline>
            <polyline
              id="path"
              points="109 369 129 369 149 389 149 397"
            ></polyline>
            <polyline
              id="path"
              points="109 377 126 377 133.071068 384.071068 133.071068 397.000195"
            ></polyline>
            <polyline
              id="path"
              points="109 345 121 345 137 329 137 309"
            ></polyline>
            <polyline
              id="path"
              points="109 337 117 337 126 328 126 320"
            ></polyline>
            <polyline
              id="path"
              points="109 361 129 361 161 329 161 309"
            ></polyline>
            <polyline
              id="path"
              points="109 353 125 353 150 328 150 320"
            ></polyline>
            <polyline
              id="path"
              points="101 329 101 313 125.020824 288.979176 173.000005 288.979176 189.989593 271.989587 189.989593 243.999998"
            ></polyline>
            <polyline
              id="path"
              points="93 329 93 309 121.017851 280.982149 169.010795 280.982149 177.996472 271.996471 177.996472 192.993715 149.001378 163.998622 149.001378 41 108.988174 0.986795729 100.999989 0.986795729"
            ></polyline>
          </g>
          <g id="C5" transform="translate(715.000000, 1027.000000)">
            <polyline
              id="path"
              points="59 329 59 295 86.5045451 267.495455 89 265 89 194 86 191 61 166 61 105 65 101 65 96"
            ></polyline>
            <polyline
              id="path"
              points="75 329 75 303 88.0384048 289.961595 105 273 105 197 117 185 117 57 96 36 85 36 70 36 61 45 41 45 37 49 30 49"
            ></polyline>
            <polyline
              id="path"
              points="67 329 67 299 87.0249844 278.975016 97 269 97 260 96.954639 192.045361 108 181 108 60 92 44 85 44 73 44 64.9377423 52.0622577 52.9998377 52.0622577 45.0309872 60.0311082 41.9998404 60.0311082"
            ></polyline>
            <polyline
              id="path"
              points="0.96159519 40 14 40 17 37 56 37 65 28 85 28 101 28 125 52 125 189 113 201 113 276 84 305 84 329"
            ></polyline>
            <polyline
              id="path"
              points="109 369 129 369 149 389 149 397"
            ></polyline>
            <polyline
              id="path"
              points="109 377 126 377 133.071068 384.071068 133.071068 397.000195"
            ></polyline>
            <polyline
              id="path"
              points="109 345 121 345 137 329 137 309"
            ></polyline>
            <polyline
              id="path"
              points="109 337 117 337 126 328 126 320"
            ></polyline>
            <polyline
              id="path"
              points="109 361 129 361 161 329 161 309"
            ></polyline>
            <polyline
              id="path"
              points="109 353 125 353 150 328 150 320"
            ></polyline>
            <polyline
              id="path"
              points="101 329 101 313 125.020824 288.979176 173.000005 288.979176 189.989593 271.989587 189.989593 243.999998"
            ></polyline>
            <polyline
              id="path"
              points="93 329 93 309 121.017851 280.982149 169.010795 280.982149 177.996472 271.996471 177.996472 192.993715 149.001378 163.998622 149.001378 41 108.988174 0.986795729 100.999989 0.986795729"
            ></polyline>
          </g>
          <g id="C4" transform="translate(1536.000000, 662.000000)">
            <polyline
              id="path"
              points="28 126 64 126 96 126 105 117 105 113"
            ></polyline>
            <polyline
              id="path"
              points="28 110 40 110 65 84 72 77 88 77 92 73 184.005435 73 204.02757 52.9778651"
            ></polyline>
            <polyline
              id="path"
              points="24 106 24 91 30 85 52 85 64.509996 72.490004 68 69 84 69 88 65 180 65 196 49 196 41 204.062258 32.9377423 204.062258 0.982339396"
            ></polyline>
            <polyline
              id="path"
              points="28 118 43 118 65 96 76 85 96 85"
            ></polyline>
            <polyline id="path" points="16 106 16 102 12 98 12 94"></polyline>
            <polyline id="path" points="0 174 0 166 8 158 8 154"></polyline>
            <path d="M15.6666667,174 L15.6666667,154" id="path"></path>
            <polyline id="path" points="33 175 24 166 24 154"></polyline>
            <polyline
              id="path"
              points="229 229 229 194 236 187 236 138 236 106 256 86 256 18 239 1 224 1"
            ></polyline>
            <polyline
              id="path"
              points="189 274 189 253 220 222 220 190 228 182 228 138 228 129 224 125 224 117"
            ></polyline>
            <polyline
              id="path"
              points="149 101 153 101 157 97 205 97 224.026298 77.9737024 236.000029 77.9737024"
            ></polyline>
          </g>
          <g id="C3" transform="translate(1024.000000, 904.000000)">
            <polyline
              id="path"
              points="56 112 203 112 236 145 236 236 308 308 380 308 400 288 440 288 472 320 524 320 528 316 528 308"
            ></polyline>
            <polyline
              id="path"
              points="56 104 207 104 243 140 243 231.005494 291.997253 280.002747 444 280.002747 456.040112 292.042859 463.065506 292.042859"
            ></polyline>
            <polyline
              id="path"
              points="56 96 211 96 252 137 252 228 296 272 447 272 455 280 490 280"
            ></polyline>
            <path
              d="M56,88 L215,88 L260,133 L260,224 C260,224 275,240 276,240 L284,240 L289,245"
              id="path"
            ></path>
            <path d="M8,120 L16,120" id="path"></path>
            <path d="M8,104 L16,104" id="path"></path>
            <polyline id="path" points="52 84 52 80 56 76 92 76"></polyline>
            <path d="M28,84 L28,80" id="path"></path>
            <polyline id="path" points="20 84 20 80 16 76 16 60"></polyline>
            <path d="M36,132 L36,124" id="path"></path>
            <polyline id="path" points="0 4 0 0 0 80 8 88 12 88 16 88"></polyline>
            <polyline id="path" points="64 136 60 136 52 128 52 124"></polyline>
          </g>
          <g id="C2" transform="translate(2199.000000, 691.000000)">
            <polyline
              id="path"
              points="85 165 85 129 93 121 93 109 93 41 102 32"
            ></polyline>
            <polyline
              id="path"
              points="93 165 93 133 101 125 101 108.96878 101 53 130 24 173 24 197 0 201 0"
            ></polyline>
            <polyline
              id="path"
              points="101 165 101 137 109 129 109 109 109 58 134 33 177 33 197 13 200 13"
            ></polyline>
            <polyline
              id="path"
              points="109 165 109 141 117 133 117 108.979176 117 61 138.023796 39.976204 182.000006 39.976204 196.98811 24.9881005 201.000018 24.9881005"
            ></polyline>
            <polyline
              id="path"
              points="117 165 117 145 125 137 125 109 125 65 142 48 185.011626 48 200.005814 33.005812 201 33.005812"
            ></polyline>
            <polyline id="path" points="29 137 29 165 49 185 65 185"></polyline>
            <polyline id="path" points="29 185 37 185 45 193 65 193"></polyline>
            <polyline id="path" points="35 230 48 217 65 217"></polyline>
            <polyline id="path" points="69 165 69 109 69 80"></polyline>
            <polyline
              id="path"
              points="12 261 21 261 29 269 45 269 69 245 69 221"
            ></polyline>
            <polyline
              id="path"
              points="11.9878067 284 53 284 85 252 85 221"
            ></polyline>
            <polyline id="path" points="77 165 77 125 81 121 81 110"></polyline>
            <polyline
              id="path"
              points="0 272 20 272 24 276 49 276 77 248 77 221"
            ></polyline>
            <polyline
              id="path"
              points="35.9999987 308.003205 41.0032034 308.003205 48.9999983 300.00641 61.0064087 300.00641 101 260.012818 101 221"
            ></polyline>
            <polyline
              id="path"
              points="121 185 153 185 169 201 201 201"
            ></polyline>
            <path d="M29,200.666667 L65,200.666667" id="path"></path>
            <polyline
              id="path"
              points="121 201 145 201 161 217 201 217"
            ></polyline>
            <polyline id="path" points="45 137 45 157 57 169 65 169"></polyline>
            <polyline
              id="path"
              points="121 169 161.012498 169 177.00625 184.993752 201 184.993752"
            ></polyline>
            <polyline id="path" points="37 137 37 161 53 177 65 177"></polyline>
            <polyline
              id="path"
              points="121 177 157 177 173 193 201 193"
            ></polyline>
            <polyline
              id="path"
              points="121 193 149 193 165 209 201 209"
            ></polyline>
            <polyline
              id="path"
              points="121 217 137 217 153 233 201 233"
            ></polyline>
            <polyline id="path" points="29 217 37 217 45 209 65 209"></polyline>
            <polyline
              id="path"
              points="121 209 141 209 157 225 201 225"
            ></polyline>
            <polyline
              id="path"
              points="23.9999921 295.98812 32.9880842 295.98812 36.976204 292 58 292 93 257 93 221"
            ></polyline>
            <path d="M108.666667,289.029405 L108.666667,221" id="path"></path>
            <polyline
              id="path"
              points="120.996096 301.000001 120.996096 289.003908 117 285.007812 117 221"
            ></polyline>
          </g>
          <g id="C1" transform="translate(1532.000000, 915.000000)">
            <polyline
              id="path"
              points="0 52 12 52 23 41 68 41 144 41 188 85 188 201 224 237 244 237 276 269 276 285 264 297 264 337 296 369 320 369"
            ></polyline>
            <polyline
              id="path"
              points="368 369 459 369 463 365 532 365 536 361 544 361 588 405 624 405"
            ></polyline>
            <polyline
              id="path"
              points="368 353 424 353 440 337 444 337 448 333"
            ></polyline>
            <polyline
              id="path"
              points="0 4 4 4 17 17 68 17 156 17 212 73 212 181 292 261 292 293 280 305 280 329 304 353 320 353"
            ></polyline>
            <polyline
              id="path"
              points="0 36 17 36 20 33 68 33 147.989584 32.9895845 196 81 196 197 212 213 232 213 284 265 284 289 272 301.285714 272 333.571429 299.428571 361 320 361"
            ></polyline>
            <polyline
              id="path"
              points="292 317 292 329 308 345 320 345"
            ></polyline>
            <polyline
              id="path"
              points="204 12 204 21 220 37 220 177 300 257 300 293 304 297 304 329 312 337 320 337"
            ></polyline>
            <polyline
              id="path"
              points="368 329 384 329 388 325 404 325"
            ></polyline>
            <polyline
              id="path"
              points="416 597 396 597 372 573 372 409 364 401 364 373"
            ></polyline>
            <polyline
              id="path"
              points="312 281 312 325 316 329 320 329"
            ></polyline>
            <polyline
              id="path"
              points="332 325 332 265 236 169 236 29 228 21 228 12"
            ></polyline>
            <polyline
              id="path"
              points="324 325 324 269 228 173 228 33 216 21 216 0"
            ></polyline>
            <polyline
              id="path"
              points="368 361 428 361 444.03122 344.96878 492 344.96878 539.000005 344.96878"
            ></polyline>
            <polyline id="path" points="368 345 420 345 452 313"></polyline>
            <polyline
              id="path"
              points="368 337 415 337 444 308 444 305 453 296"
            ></polyline>
            <polyline
              id="path"
              points="328 489 327.984385 441.015635 315.96878 429.000031 315.96878 413.03122 332 397 332 373"
            ></polyline>
            <polyline id="path" points="307 406 324 389 324 373"></polyline>
            <polyline
              id="path"
              points="327 417 327 414 340 401 340 373"
            ></polyline>
            <polyline
              id="path"
              points="340 433 340 413 348 405 348 373"
            ></polyline>
            <polyline
              id="path"
              points="340 325 340 261 244 165 244 25 240 21 240 1"
            ></polyline>
            <polyline
              id="path"
              points="356 325 356 237 372 221 372 212"
            ></polyline>
            <polyline
              id="path"
              points="416 605 391 605 364 578 364 414 356 406 356 373"
            ></polyline>
            <polyline
              id="path"
              points="364 325 364 241 384 221 384 201"
            ></polyline>
          </g>
        </g>
      </svg>
    </div>
  );
}
